import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import { filterBy, orderBy, process } from "@progress/kendo-data-query";
import React, { useEffect } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import "../../Styles/ProjectHome.scss";
import { Popup } from "@progress/kendo-react-popup";
import RecentlyViewedActions from "./RecentlyViewedActions";
import { Sortable } from "@progress/kendo-react-sortable";
import SortableWidgetUiHome from "../Dashboard/SortableWidgetUiHome";
import RiskColumns from "./RiskColumns.json";
import ImpactEditComponent from "./Component/ImpactEditComponent";
import ColumnMenuFilter from "../Dashboard/ColumnMenuFilter";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import * as moment from "moment";
import { formatNumber } from "@telerik/kendo-intl";
import ExistingControlCell from "./Component/ExistingControlCell";
import PrePostComponenant from "./Component/PrePostComponenant";
import RiskAlertStackHolderComponent from "./Component/RiskAlertStackHolderComponent";
import RiskCauseCell from "./Component/RiskCauseCell";
import RiskCommonCell from "./Component/RiskCommonCell";
import RiskDescriptionCell from "./Component/RiskDescriptionCell";
import RiskFrequencyComponent from "./Component/RiskFrequencyComponent";
import RiskProximityDateCell from "./Component/RiskProximityDateCell";
import StatusComponent from "./Component/StatusComponent";
import OwnerDropDownCell from "./OwnerDropDownCell";
import DropDownCell from "./RiskTypeDropDownCell";
import ThreatAndOpportunities from "./ThreatAndOpportunities";
import RiskTitleCell from "./Component/RiskTitleCell";
import RiskProgressPopup from "./Component/RiskProgressPopup";
import PersistenceRiskHome from "./PersistenceRiskHome.json";
import ActionPersistenceHome from "./ActionPersistenceHome.json";
import { SearchMenu } from "../Dashboard/SearchMenu";
import { CustomFieldSearchMenu } from "../Dashboard/CustomFieldSearchMenu";
import RiskCustomFieldDropdownCell from "./Component/RiskCustomFieldDropdownCell";
import RiskCustomFieldSingleDropdownCell from "./Component/RiskCustomFieldSingleDropdownCell";
import RiskCustomFieldFreeText from "./Component/RiskCustomFieldFreeText";
import RiskCustomFieldNumeric from "./Component/RiskCustomFieldNumeric";
import RiskCustomFieldDate from "./Component/RiskCustomFieldDate";
import QualitativeImpactEditComponent from "./Component/QualitativeImpactEditComponent";
import { ColumnMenuCheckboxFilter } from "../Dashboard/ColumnMenuCheckboxFilter";
import RiskRegisterFormView from "./Component/RiskRegisterFormView";
import { mapTree } from "@progress/kendo-react-treelist";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { MitigationExpandEdit } from "./MitigationExpandEdit";
import GridExpandComponent from "./Component/GridExpandCompoent";
import { useRef } from "react";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { NavLink } from "react-router-dom";
import RecentlyViewedTasks from "../Tasks/RecentlyViewedTasks";
import { RecentlyViewedTasksActions } from "../Tasks/RecentlyViewedTasksActions";
import PersistenceTasks from "./PersistenceTasks.json";
import PersistenceTaskAction from "../Tasks/PersistenceTaskAction.json"

var selectedColumn = undefined;
var existingFilter = [];
var existingFilterV1 = [];
var currentEditField = undefined;
var currentChangedValue = {};
var cellAddValue = "";
var riskTypeList = [];
var riskTypemaster = [];
var customFieldsData = [];
var masterRiskList = [];
var heatmapCount=0;
var TenantUsers=[];
var userListdropdown=[];
var Enableselectuser=undefined;
export default function ProjectHome(props) {
  secureLocalStorage.setItem("ActivePage", "Home");
  const [opportunitiesList, setOpportunitiesList] = React.useState([
    { text: "Threat", value: "Threat" },
    { text: "Opportunity", value: "Opportunity" },
  ]);
  const [loader, setLoader] = React.useState(false);
  const [isReportLoaded, setIsReportLoaded] = React.useState(false);
  const [data, setData] = React.useState([]);
  // const [currentChangedValue, setCurrentChangedValue] = React.useState({});
  // const [masterRiskList,setMasterRiskList] = React.useState([]);
  const [dataState, setDataState] = React.useState({});
  const [riskCount, setRiskCount] = React.useState({});
  const [actionCount, setActionCount] = React.useState({});
  const [aggregationsCount, setAggregationsCount] = React.useState({});
  const [recentChartData, setRecentChartData] = React.useState([]);
  const [selectedWgts, setSelectedWgts] = React.useState("");
  const [riskActionData, setRiskActionData] = React.useState([]);
  const [editField, setEditField] = React.useState(undefined);
  const [sort, setSort] = React.useState([]);
  const [persistenceRiskGrid, setPersistenceRiskGrid] =
    React.useState(PersistenceRiskHome);
  const [persistenceActionGrid, setPersistenceActionGrid] = React.useState(
    ActionPersistenceHome
  );
  const [impactColumns, setImpactColumns] = React.useState([]);
  // const [riskTypeList, setRiskTypeList] = React.useState([]);
  // const [riskTypemaster,setRiskTypemaster] = React.useState([]);
  const [fixedGrid, setFixedGrid] = React.useState(true);

  const [stackeHolderList, setStackeHolderList] = React.useState([]);
  const [ownerListForRisk, setOwnerListForRisk] = React.useState([]);
  const [userList, setUserList] = React.useState([]);
  const [dropdownColumns, setDropdownColumns] = React.useState([]);
  const [customFieldsDataState, setCustomFieldsDataState] = React.useState([]);
  const [actionTypeListForRisk, setActionTypeListForRisk] = React.useState([]);
  const [isPrimeWorkstreams,setIsPrimeWorkstreams] = React.useState(false);
  const [organisationUnitListForRisk,setOrganisationUnitListForRisk]= React.useState([]);
  const [organisationUnitListForTask,setOrganisationUnitListForTask]= React.useState([]);

  const [orgUnit, setOrgUnit] = React.useState({});
  const[riskOwnerByTenant,setRiskOwnerByTenant]= React.useState(undefined);
  const[actionOwnerByTenant,setActionOwnerByTenant]= React.useState(undefined);
  const[taskOwnerByTenant,setTaskOwnerByTenant]= React.useState(undefined);
  const[taskActionsOwnerByTenant,setTaskActionsOwnerByTenant]= React.useState(undefined);
  const [taskActionsList,setTaskActionsList ]= React.useState([]);
  const [formEditFlag,setFormEditFlag] = React.useState(false);
  const [showFormView,setShowFormView]= React.useState(false);
  const [formData,setFormData]= React.useState({});
  const [expandedRowList, setExpandRowList] = React.useState([]);
  const [priorityRankingsList,setPriorityRankingsList]=React.useState([]);
const effortUnitId=0;
  const [filter, setFilter] = React.useState({
    logic: "and",
    filters: [],
  });
  const filterOperators = {
    text: [
      { text: "grid.filterContainsOperator", operator: "contains" },
      { text: "grid.filterNotContainsOperator", operator: "doesnotcontain" },
      { text: "grid.filterEqOperator", operator: "eq" },
      { text: "grid.filterNotEqOperator", operator: "neq" },
      { text: "grid.filterStartsWithOperator", operator: "startswith" },
      { text: "grid.filterEndsWithOperator", operator: "endswith" },
      { text: "grid.filterIsNullOperator", operator: "isnull" },
      { text: "grid.filterIsNotNullOperator", operator: "isnotnull" },
      // { text: 'grid.filterIsEmptyOperator', operator: 'isempty' },
      // { text: 'grid.filterIsNotEmptyOperator', operator: 'isnotempty' }
    ],
    numeric: [
      { text: "grid.filterEqOperator", operator: "eq" },
      { text: "grid.filterNotEqOperator", operator: "neq" },
      { text: "grid.filterGteOperator", operator: "gte" },
      { text: "grid.filterGtOperator", operator: "gt" },
      { text: "grid.filterLteOperator", operator: "lte" },
      { text: "grid.filterLtOperator", operator: "lt" },
      { text: "grid.filterIsNullOperator", operator: "isnull" },
      { text: "grid.filterIsNotNullOperator", operator: "isnotnull" },
    ],
    date: [
      { text: "grid.filterEqOperator", operator: "eq" },
      { text: "grid.filterNotEqOperator", operator: "neq" },
      { text: "grid.filterAfterOrEqualOperator", operator: "gte" },
      { text: "grid.filterAfterOperator", operator: "gt" },
      { text: "grid.filterBeforeOperator", operator: "lt" },
      { text: "grid.filterBeforeOrEqualOperator", operator: "lte" },
      { text: "grid.filterIsNullOperator", operator: "isnull" },
      { text: "grid.filterIsNotNullOperator", operator: "isnotnull" },
    ],
    boolean: [{ text: "grid.filterEqOperator", operator: "eq" }],
  };
  const myRef = useRef();
  const myrecentactivity = useRef();
  const history = useHistory();
  const [actionLoad,setActionLoad]=React.useState(false);
  const [riskLoad,setRiskLoad]=React.useState(false);
  const [taskLoad,setTaskLoad]=React.useState(false);

  const [value,setvalue]=React.useState("RiskRegister");
 

  useEffect(() => {
    isAuthorizeUse();

    setDataState({
      sort: [],
      take: 10,
      skip: 0,
    });
  }, []);

  useEffect(() => {}, [currentChangedValue]);

  useEffect(() => {
    getTaskMetricsAsync();
  }, [taskOwnerByTenant,taskActionsOwnerByTenant]);

  const isAuthorizeUse = async () => {
    if (!secureLocalStorage.getItem("authToken")) {
      if (props.match.params.id) {
        history.push({
          pathname: `/tenant/${props.match.params.id}`,
        });
      } else {
        history.push({
          pathname: "/",
        });
      }
    } else {
      setRiskLoad(true);
      setActionLoad(true);
      setTaskLoad(true);
      getOrganizationsUnitsForRisk();
      getOrganizationsUnitsForTask();
      existingFilter = [];
      getRiskTypeList();
      let res = await getCustomField();
      customFieldsData = res;
      setCustomFieldsDataState(res);
      getMatrixColorCodes();
      getLetestWidgetForHome();
      getWorkstreamUsers();
      getAllTenantUserList();
      getActionTypeList();
      await getHomeRiskPersistance();
      await getHomePersistance();
      await getTaskPersistence("HomeTask");
      await getTaskPersistence("HomeTaskAction");
       getTaskPersistence("ACTION-EXPAND-HOME");
       getTaskPersistence("ACTIVITY-EXPAND-HOME");
       homeRisksByOwner();
       homeActionsByOwner();
       homeTaskActionsByOwner();
       getPriorityRankings();
    }
  };
  const getPriorityRankings = async () => {
    try {
      let response = await Api.getPriorityRankings();
      if (response.status === 200) {
        let rankingList = [];

        for (var i = 0; i < response.priorityRankings.length; i++) {
          rankingList.push({
            value: response.priorityRankings[i].priorityRankingId,
            text: response.priorityRankings[i].priorityRankingName,
          });
        }
        setPriorityRankingsList(rankingList);
      } 
    } catch (error) {
      console.error(error);
    }
  };
   const getOrganizationsUnitsForRisk = async () => {
    try {
      var createdby =parseInt(secureLocalStorage.getItem("loginUserId"));
      var request = {
        CreatedBy: createdby,
        IsTasksModule:false
      };
      let response = await Api.getOrgUnits(request);
      if (response.status === 200) {
        setOrganisationUnitListForRisk(response.organisationUnit);
      } else {
        setOrganisationUnitListForRisk([]);
      }
    } catch (error) {
      setOrganisationUnitListForRisk([]);
      console.error(error);
    }
  };

  const getOrganizationsUnitsForTask = async () => {
    try {
      var createdby =parseInt(secureLocalStorage.getItem("loginUserId"));
      var request = {
        CreatedBy: createdby,
        IsTasksModule:true
      };
      let response = await Api.getOrgUnits(request);
      if (response.status === 200) {
        setOrganisationUnitListForTask(response.organisationUnit);
      } else {
        setOrganisationUnitListForTask([]);
      }
    } catch (error) {
      setOrganisationUnitListForTask([]);
      console.error(error);
    }
  };

  const refreshTextNarative = (text, widgetId) => {
    let data =
      recentChartData &&
      recentChartData.map((item) => {
        if (item.widgetId == widgetId) {
          item["textNarrative"] = text;
        }
        return item;
      });
    setRecentChartData(data);
  };

  const getActionTypeList = async () => {
    try {
      let req = {};
      let response = await Api.getProjectStage(req);
      if (response.status === 200 && response.actionTypes) {
        var tempActionTypeList = [];

        for (var i = 0; i < response.actionTypes.length; i++) {
          tempActionTypeList.push({
            value: response.actionTypes[i].actionId,
            text: response.actionTypes[i].name,
          });
        }
        let newFirstElement={
          value: null,
          text: " [blank]",
        }
        tempActionTypeList=[newFirstElement].concat(tempActionTypeList);
        setActionTypeListForRisk(tempActionTypeList);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  //Custom fields
  const createDynamicDropdowns = (products, filter) => {
    let dropdownColumn = [];
    products.map((res) => {
      res.customFields&&res.customFields.map((item) => {
        if (dropdownColumn.length > 0) {
          if (!dropdownColumn.find((cf) => cf.fieldName == item.fieldName)) {
            dropdownColumn.push({
              fieldName: item.fieldName,
              data: getCustomFieldMasterData(item.fieldName, filter),
              inputType: getInputType(item.fieldName),
            });
          }
        } else {
          dropdownColumn.push({
            fieldName: item.fieldName,
            data: getCustomFieldMasterData(item.fieldName, filter),
            inputType: getInputType(item.fieldName),
          });
        }
      });
    });
    if (dropdownColumn.length > 0) {
      products.map((res) => {
        dropdownColumn.map((col) => {
          let temp = res.customFields&&res.customFields.find(
            (item) => item.fieldName === col.fieldName
          );
          if (temp) {
            if (temp.inputType === "Multi Drop Down") {
              let val = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
              let hashArr = stringToHashForCF(val, col.data);
              res[col.fieldName] = hashArr;
            } else if (temp.inputType === "Single Drop Down") {
              let val = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
              res[col.fieldName] = val;
            } else if (temp.inputType === "Free Text") {
              let val = temp.multiText;
              res[col.fieldName] = val;
            } else if (temp.inputType === "Numeric") {
              let val = temp.multiText ? parseInt(temp.multiText) : "";
              res[col.fieldName] = val;
            } else if (temp.inputType === "Date") {
              let val = temp.multiText ? new Date(temp.multiText) : undefined;
              res[col.fieldName] = val;
            }
          } else {
            res[col.fieldName] = "";
          }
        });
      });
    }
    let columnsToShow = [];
    if (dropdownColumn.length > 0) {
      columnsToShow = dropdownColumn.map((item) => (
        <GridColumn
          field={item.fieldName}
          title={item.fieldName}
          resizable={true}
          reorderable={true}
          width="200px"
          cell={(props) => getCustomFieldComponent(props, products, item)}
          columnMenu={(props) => getCustomFieldColumnMenu(props, item)}
          filter={getCustomFieldFilter(item)}
          headerClassName={checkItsinFilterOrNot(item.fieldName, filter)}
        />
      ));
    }
    setDropdownColumns(columnsToShow);
  };

  const getCustomFieldFilter = (item) => {
    if (item.inputType === "Multi Drop Down") {
      return "";
    } else if (item.inputType === "Single Drop Down") {
      return "text";
    } else if (item.inputType === "Free Text") {
      return "";
    } else if (item.inputType === "Numeric") {
      return "numeric";
    } else if (item.inputType === "Date") {
      return "date";
    } else {
      return "text";
    }
  };
  const stringToHashForCF = (stringArr, data) => {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name == item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name == stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    return hashArr.toString();
  };
  const getcustomfieldfilterlist=(list)=>{
    var sorted_arr =  list.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

    return sorted_arr
  }
  const getsortedrisklist=()=>{
    var sorted_arr =  riskTypeList.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
    return sorted_arr
  }
  const getCustomFieldColumnMenu = (props, item) => {
    if (item.inputType === "Multi Drop Down") {
      getcustomfieldfilterlist(item.data);
      return (
        <CustomFieldSearchMenu
          {...props}
          customFieldsmaster={item.data}
          existingFilter={existingFilter ? existingFilter : existingFilterV1}
          filterChangeV={filterChangeV}
          clearFilter={clearFilter}
        />
      );
    }else if(item.inputType === "Single Drop Down"){
      return (                      
        <ColumnMenuCheckboxFilter
          {...props}
          data={masterRiskList}
          getSelectedColumn={getSelectedColumn}
        />
      )
    } else {
      return (
        <ColumnMenuFilter {...props} getSelectedColumn={getSelectedColumn} />
      );
    }
  };
  const getCustomFieldComponent = (props, products, cfObj) => {
    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      return (
        <RiskCustomFieldDropdownCell
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          // manageCustomValuesSave={manageCustomValuesSave}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <RiskCustomFieldSingleDropdownCell
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          // manageCustomValuesSave={manageCustomValuesSave}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <RiskCustomFieldFreeText
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          // manageCustomValuesSave={manageCustomValuesSave}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <RiskCustomFieldNumeric
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          // manageCustomValuesSave={manageCustomValuesSave}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <RiskCustomFieldDate
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          // manageCustomValuesSave={manageCustomValuesSave}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else {
      return <td></td>;
    }
  };

  const getInputType = (fieldName) => {
    try {
      if (customFieldsData.length == 0) {
        customFieldsData = customFieldsDataState;
      }
      let arr = customFieldsData.find((item) => item.fieldName == fieldName);
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.log(err);
    }
  };

  const manageCustomValues = async (updateDate) => {
    let type = getInputType(updateDate.inEdit);
    if ((type && type === "Multi Drop Down") || type === "Single Drop Down") {
      updateRiskRegistor(updateDate, false);
    } else {
      let dirtData = masterRiskList.find(
        (item) => updateDate.riskRegisterId == item.riskRegisterId
      );
      if (
        dirtData &&
        updateDate[updateDate.inEdit] == dirtData[updateDate.inEdit]
      ) {
        exitEdit();
        return;
      } else {
        updateRiskRegistor(updateDate, false);
      }
    }
  };

  const getCustomFieldMasterData = (fieldName, filter) => {
    try {
      if (customFieldsData.length == 0) {
        customFieldsData = customFieldsDataState;
      }
      let arr = customFieldsData.filter((item) => item.fieldName == fieldName);
      if (arr && arr.length > 0) {
        let temp = [];

        arr[0].cfPossibleValues.map((item, index) => {
          let checked = checkCFinFilterValuesOrNot(
            fieldName,
            item.hashValue,
            filter
          );
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: checked,
            hashValue: item.hashValue,
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };

 

  const [HeatMapConfigDataOpportunity, setHeatMapConfigDataOpportunity] = React.useState([]);
  const [HeatMapConfigDataThreat, setHeatMapConfigDataThreat] = React.useState([]);
  const [dynamicHeatmapProbabilityRange, setDynamicHeatmapProbabilityRange] = React.useState([]);

  const getMatrixColorCodes = async () => {
    try {
      var req = {
        WorkstreamId: 0,
      };
      let response = await Api.MatrixColor(req);
      if (response.status === 200) {
        heatmapCount=response.heatmapCount;
        // normal,opportunity
       let normal_opp = response.matrixColor.find(
        (item) => item.riskType === "opportunity"
      );
      let opp_colorJsonData = JSON.parse(normal_opp.colorJsonData);

      //  normal,threat
      let normal_threat = response.matrixColor.find(
        (item) => item.riskType === "threat"
      );
      let threat_colorJsonData = JSON.parse(normal_threat.colorJsonData);
      setHeatMapConfigDataOpportunity(opp_colorJsonData);
      setHeatMapConfigDataThreat(threat_colorJsonData);
      setDynamicHeatmapProbabilityRange(response.dynamicHeatmapProbabilityRange);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getAllTenantUserList = async () => {
    try {
      let response = await Api.getuserAddedByTenant();
      if (response.status === 200 && response.tenantUsers) {
        TenantUsers=response.tenantUsers
        var typeList = [];
        var tempUserList = [];
        let stackeHolderList = [];
        for (var i = 0; i < response.tenantUsers.length; i++) {
          tempUserList.push({
            value: response.tenantUsers[i].userId,
            text: response.tenantUsers[i].name,
          });
          typeList.push(response.tenantUsers[i].name);
          stackeHolderList.push({
            userId: response.tenantUsers[i].userId,
            displayName:
              response.tenantUsers[i].name +
              " (" +
              response.tenantUsers[i].emailAddress +
              ")",
            email: response.tenantUsers[i].emailAddress,
          });
        }
        let newFirstElement={
          value: null,
          text: " [blank]",
        }
        tempUserList=[newFirstElement].concat(tempUserList);
        setOwnerListForRisk(tempUserList);
        setStackeHolderList(stackeHolderList);
      }
    } catch (error) {
      setLoader(false);

      console.error(error);
    }
  };

  const getWorkstreamUsers = async () => {
    try {
      let req = {
        orgId: parseInt(props.match.params.organizationUnitId),
      };
      let response = await Api.getWorkstreamUsers(req);
      if (response.status === 200 && response.tenantUsers) {
        var tempUserList = [];
        for (var i = 0; i <  response.tenantUsers.length; i++) {
          tempUserList.push({
            value: response.tenantUsers[i].userId,
            text: response.tenantUsers[i].name,
          });
        }
        setUserList(tempUserList);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const getCustomField = async () => {
    let res = [];
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };

      let response = await Api.getCustomField(request);
      if (response.status == 200) {
        response.customFields.map((item) => {
          item.cfPossibleValues.map((item1) => {
            item1["hashValue"] = convertStrToHash(item1.possibleValues);
          });
          if(item.inputType=="Single Drop Down"){
            let newFirstElement = {
              "hashValue":"",
              "id": 0,
              "possibleValues": " [blank]",
            }
            item["cfPossibleValues"] = [newFirstElement].concat(item.cfPossibleValues);
            item["possibleValues"]=[" [blank]"].concat(item.possibleValues);
          }else if(item.inputType=="Multi Drop Down"){
            let newFirstElement = {
              "hashValue":"",
              "id": 0,
              "possibleValues": " [blank]",
            }
           
            item["cfPossibleValues"] = [newFirstElement].concat(item.cfPossibleValues);
            item["possibleValues"]=[" [blank]"].concat(item.possibleValues);
          }
        });
        res = response.customFields;
        setCustomFieldsDataState(response.customFields);
      }
    } catch (err) {
      console.error("Exception:", err);
    }
    return res;
  };

  const getRiskTypeList = async () => {
    var typeList = [];
    try {
      let response = await Api.getRiskType();
      if (response.status === 200 && response.riskTypes) {
        for (var i = 0; i < response.riskTypes.length; i++) {
          if (response.riskTypes[i].name && response.riskTypes[i].name != "") {
            typeList.push({
              value: response.riskTypes[i].riskTypeId,
              text: response.riskTypes[i].name,
              id: response.riskTypes[i].riskTypeId,
              name: response.riskTypes[i].name,
              checked: false,
              hashValue: convertStrToHash(response.riskTypes[i].name),
            });
          }
        }
        let newFirstElement = {
          value: "undefined",
          text: "undefined",
          id: 0,
          name: " [blank]",
          checked: false,
          hashValue: "undefined",
        }
        typeList = [newFirstElement].concat(typeList);
        riskTypeList = [...typeList];
        riskTypemaster = [...typeList];
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCellAddValue = (element) => {
    cellAddValue = element;
  };

  const homeActionsByOwner = async (id,flag) => {
    try{
      let ownerId=secureLocalStorage.getItem("loginUserId");
      if(flag==="ByDropdown"){
        ownerId=id;
      }else if(actionOwnerByTenant?.value){
        ownerId=actionOwnerByTenant.value
      }
      
    let response = await Api.homeActionsByOwner(ownerId);
    if (response.status == 200) {
      response.riskMitigationResponse.map((riskReg) => {
        
        riskReg.actualCompletionDate = riskReg.actualCompletionDate
          ? new Date(riskReg.actualCompletionDate)
          : undefined;
        riskReg.projectedCompletionDate = riskReg.projectedCompletionDate
          ? new Date(riskReg.projectedCompletionDate)
          : undefined;
        riskReg.originalCompletionDate = riskReg.originalCompletionDate
          ? new Date(riskReg.originalCompletionDate)
          : undefined;
        riskReg.proximityDate = riskReg.proximityDate
          ? new Date(riskReg.proximityDate)
          : undefined;
          // riskReg.createdDate = riskReg.createdDate
          // ? new Date(riskReg.createdDate)
          // : undefined;
          if (riskReg.createdDate) {
            var time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          } else {
            riskReg.createdDate = null;
          }
          if (riskReg.updatedDate) {
            // riskReg.updatedDate = new Date(riskReg.updatedDate);
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          }
          if (riskReg.closedDate) {
            var time = moment(riskReg.closedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let closedDate = time;
            riskReg.closedDate = riskReg.closedDate
              ? new Date(closedDate)
              : "";
          }
          riskReg["spi"] = parseInt(riskReg.spi);
          riskReg["percentageCompletion"] = parseInt(
            riskReg.percentageCompletion
          );
          riskReg["isOpen"]=riskReg.isOpen?"Open":"Closed";
          riskReg["approved"]=riskReg.approved?"Yes":"No";
      });
      setRiskActionData(response.riskMitigationResponse);
      setActionLoad(false);
      getRiskCount(id, "ACTION");
    } else {
      setActionLoad(false);
      setRiskActionData([]);
      getRiskCount(id, "ACTION");
    }
    }catch(err){
      console.error(err);
      setLoader(false);
      // setActionLoad(false);
      setRiskActionData([]);
    }
    
  };
  const homeTaskActionsByOwner = async (id,flag) => {
    try{
      // setTaskActionsList([]);
      let ownerId=secureLocalStorage.getItem("loginUserId");
      if(flag==="ByDropdown"){
        ownerId=id;
      }else if(taskActionsOwnerByTenant?.value){
        ownerId=taskActionsOwnerByTenant.value
      }
      
    let response = await Api.homeTaskActionsByOwner(ownerId);
    if (response.status == 200&&response.taskActions) {
      
      response.taskActions.map((riskReg)=>{
        if (riskReg.originalCompletionDate) {
          riskReg.originalCompletionDate =new Date(riskReg.originalCompletionDate); //riskReg.originalCompletionDate? moment(new Date(riskReg.originalCompletionDate)).format("DD-MMM-YYYY"):null;
        }
        if (riskReg.projectedCompletionDate) {
          riskReg.projectedCompletionDate =new Date(riskReg.projectedCompletionDate);//riskReg.projectedCompletionDate? moment(new Date(riskReg.projectedCompletionDate)).format("DD-MMM-YYYY"):null;
        }
        if (riskReg.actualCompletionDate) {
          riskReg.actualCompletionDate =new Date(riskReg.actualCompletionDate);//riskReg.actualCompletionDate? moment(new Date(riskReg.actualCompletionDate)).format("DD-MMM-YYYY"):null;
        }
        if (riskReg.proximityAlertDate) {
          riskReg.proximityAlertDate = new Date(riskReg.proximityAlertDate);//riskReg.proximityAlertDate? moment(new Date(riskReg.proximityAlertDate)).format("DD-MMM-YYYY"):null;
        }
        if (riskReg.updatedDate) {
          var time = moment(riskReg.updatedDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let updatedDate = time;
          riskReg.updatedDate = riskReg.updatedDate
            ? new Date(updatedDate)
            : "";
        }
        if (riskReg.createdDate) {
          let time = moment(riskReg.createdDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let createdDate = time;
          riskReg.createdDate = riskReg.createdDate
            ? new Date(createdDate)
            : "";
        }
        if (riskReg.closedDate) {
          let time = moment(riskReg.closedDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let closedDate = time;
          riskReg.closedDate = riskReg.closedDate
            ? new Date(closedDate)
            : "";
        }
         if (riskReg.isClosed === false) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg.isApproved === false) {
            riskReg.isApproved = "No";
          } else {
            riskReg.isApproved = "Yes";
          }
      })
      setTaskActionsList(response.taskActions);
      setLoader(false);
      setTaskLoad(false);
    } else{
      setTaskLoad(false);
      setLoader(false);
      setTaskActionsList([]);
    }
    }catch(err){
      console.error(err);
      setLoader(false);
      setTaskLoad(false);
      setTaskActionsList([]);
    }
    
  };
  const [taskMetrics, setTaskMetrics] = React.useState({});
    const [taskActionMetrics, setTaskActionMetrics] = React.useState({});
    const getTaskMetricsAsync = async () => {
      try {
        let loginId=parseInt(secureLocalStorage.getItem("loginUserId"));
        var req = {
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          screenFrom: "Home",
          TaskUserId: taskOwnerByTenant?taskOwnerByTenant.value:loginId,
          TaskActionUserId: taskActionsOwnerByTenant?taskActionsOwnerByTenant.value:loginId
        };
        let response = await Api.getTaskMetricsAsync(req);
        if (response.status === 200 && response.tasksMetricsResponse) {
          setTaskMetrics(response.tasksMetricsResponse);
          setTaskActionMetrics(response.taskActionsMetricsResponse);
        }
      } catch (error) {
        console.error(error);
      }
    };
  
  const getRiskCount = async (id, flag) => {
    try {
      let ownerId = secureLocalStorage.getItem("loginUserId");
      let RiskUserId = ownerId;
      let ActionUserId = ownerId;
      if (flag==="RISK"&&id) {
        RiskUserId = id;
        ActionUserId = actionOwnerByTenant?actionOwnerByTenant.value:ownerId;
      }else if (flag==="ACTION"&&id) {
        ActionUserId = id;
        RiskUserId = riskOwnerByTenant?riskOwnerByTenant.value:ownerId;
      }else if(riskOwnerByTenant&&actionOwnerByTenant){
        ActionUserId = actionOwnerByTenant?actionOwnerByTenant.value:ownerId;
        RiskUserId = riskOwnerByTenant?riskOwnerByTenant.value:ownerId;
      }

      var req = {
        orgId: 1, //for BE default
        CreatedBy: secureLocalStorage.getItem("loginUserId"),
        RiskUserId: RiskUserId,
        ActionUserId: ActionUserId,
        type: "Home",
      };
      let response = await Api.getRiskCount(req);
      if (response.status === 200 && response.riskCountResponses) {
        setRiskCount(response.riskCountResponses);
        setActionCount(response.actionCountResponse);
        setAggregationsCount(response.aggregations);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };
  const processInput=(input) =>{
    if (typeof input === "string") {
      return input.split(",").map((item) => item.trim()); // Optional: trim spaces around items
    } else if (Array.isArray(input)) {
      return input;
    } else {
      return [];
    }
  }
  const getLetestWidgetForHome = async () => {
    try {
      var req = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getLetestWidgetForHome(req);
      if (response.status === 200) {
        setRecentChartData(response.chartData);
        setIsReportLoaded(true);
        setLoader(false);
      } else {
        setRecentChartData([]);
        setIsReportLoaded(true);
        setLoader(false);
      }
      // console.clear();
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const homeRisksByOwner = async (id,flag) => {
    try {
      
      let ownerId=secureLocalStorage.getItem("loginUserId");
      if(flag==="ByDropdown"){
        ownerId=id;
      }else if(riskOwnerByTenant?.value){
        ownerId=riskOwnerByTenant.value
      }
      
      let response = await Api.homeRisksByOwner(ownerId);
      if (response.status == 200) {
        let impactMasterTemp = [];
        response.riskRegister.map((riskReg) => {
          if (expandedRowList.includes(riskReg.riskRegisterId)) {
            riskReg["expanded"] = true;
          } else {
            riskReg["expanded"] = false;
          }
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          
          if (riskReg.createdDate) {
            var time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          }
          if (riskReg.updatedDate) {
            // riskReg.updatedDate = new Date(riskReg.updatedDate);
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          }
          if (riskReg.closedDate) {
            var time = moment(riskReg.closedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let closedDate = time;
            riskReg.closedDate = riskReg.closedDate
              ? new Date(closedDate)
              : "";
          }
          if (riskReg.riskTypeNames) {
            riskReg["riskTypeNamesExport"] = riskReg.riskTypeNames.toString();
            let hashArr = stringToHash(
              riskReg.riskTypeNames.toString(),
              "riskTypeNames"
            );
            riskReg["riskTypeNames"] = hashArr;
          }else{
            riskReg["riskTypeNames"] = "undefined";
            riskReg["riskTypeNamesExport"]="";
          }
          if (riskReg.riskAlertStakeHolders) {
            riskReg["riskAlertStakeHolders"] =
              riskReg["riskAlertStakeHolders"].toString();
          }
          if (riskReg.isClosed) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          impactMasterTemp = [...impactMasterTemp, ...riskReg.impactResponse];
        });

        impactMasterTemp = impactMasterTemp.filter(
          (ele, ind) =>
            ind ===
            impactMasterTemp.findIndex(
              (elem) =>
                elem.name === ele.name &&
                elem.impactType === ele.impactType &&
                elem.type === ele.type
            )
        );
        // await createDynamicCols(response.riskRegister, impactMasterTemp);
        // await createDynamicDropdowns(response.riskRegister);
        let filter = existingFilter ? existingFilter : [];
        await createDynamicCols(response.riskRegister, impactMasterTemp, filter);
        await createDynamicDropdowns(response.riskRegister, filter);
        await checkRisktypeSelections(filter);
        const result = filterBy(response.riskRegister, filter);
        setIsPrimeWorkstreams(response.isPrimeWorkstreams);
        setData(result);
        setRiskLoad(false);
        masterRiskList = response.riskRegister;
        getRiskCount(id, "RISK");
      }else{
        setRiskLoad(false);
        setData([]);
        masterRiskList = [];
        getRiskCount(id, "RISK");
      }
    } catch (error) {
      console.error(error);
      // setRiskLoad(false);
      setData([]);
      masterRiskList = [];
    }
  };

  //Imapcts
  const createDynamicCols = async (products, impactMasterTemp, filter) => {
    let impactColumn = [];
    products.map((res) => {
      res.impactResponse&&res.impactResponse.map((item) => {
        if (impactColumn.length > 0) {
          if (!impactColumn.find((cf) => cf.fieldName == item.fieldName)) {
            impactColumn.push({
              fieldName: item.name + "_" + item.type,
              impactType: item.impactType,
            });
          }
        } else {
          impactColumn.push({
            fieldName: item.name + "_" + item.type,
            impactType: item.impactType,
          });
        }
        // }
      });
    });

    impactColumn = impactColumn.filter(
      (ele, ind) =>
        ind ===
        impactColumn.findIndex(
          (elem) =>
            elem.fieldName === ele.fieldName &&
            elem.impactType === ele.impactType
        )
    );
    if (impactColumn.length > 0) {
      products.map((res) => {
        impactColumn.map((col) => {
          if (col.impactType == "Qualitative") {
            let temp = res.impactResponse&&res.impactResponse.find(
              (item) => item.name + "_" + item.type === col.fieldName
            );
            if (temp&&temp.type == "Post") {
              res[col.fieldName] =  temp.postQvalue;
            }else if (temp&&temp.type == "Pre"){
              res[col.fieldName] =temp.qValue;
            }else if (temp&&temp.type == "Current"){
              res[col.fieldName] =temp.currentQvalue;
            } else {
              res[col.fieldName] = 0;
            }
          } else {
            let temp = res.impactResponse&&res.impactResponse.find(
              (item) => item.name + "_" + item.type === col.fieldName
            );
            if (temp&&temp.type == "Post") {
              res[col.fieldName] =  temp.postImpactValue;
            }else if (temp&&temp.type == "Pre"){
              res[col.fieldName] = temp.value;
            }else if (temp&&temp.type == "Current"){
              res[col.fieldName] = temp.currentImpactValue;
            } else {
              res[col.fieldName] = 0;
            }
          }
        });
      });
    }
    let columnsToShow = [];
    if (impactColumn.length > 0) {
      columnsToShow = impactColumn.map((item) => (
        <GridColumn
          filter={"numeric"}
          field={item.fieldName}
          resizable={true}
          reorderable={true}
          title={getImpactUnit(item, impactMasterTemp)}
          cell={(props) => getImpactCellComponent(props, products, item)}
          editable={true}
          width={100}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={checkItsinFilterOrNot(item.fieldName, filter)}
        />
      ));
    }
    setImpactColumns(columnsToShow);
  };

  const setClassName = (field) => {
    let headerClassName = "";
    if (filter && filter.filters) {
      filter.filters.map((filter) => {
        if (filter.field === field) {
          headerClassName = "active";
        }
        if (filter.filters) {
          filter.filters.map((innerFilter) => {
            if (innerFilter.field === field) {
              headerClassName = "active";
            }
          });
        }
      });
    }
    return headerClassName;
  };

  const checkItsinFilterOrNot = (field, exfilter) => {
    try {
      let headerClassName = "";
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field) {
            headerClassName = "active";
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field) {
                headerClassName = "active";
              }
            });
          }
        });
        return headerClassName;
      }
    } catch (err) {}
  };

  const checkRisktypeSelections = (exfilter) => {
    // let temp = [];
    // riskTypemaster.map((item) => {
    //   let checked = checkCFinFilterValuesOrNot(
    //     "riskTypeNames",
    //     item.hashValue,
    //     exfilter
    //   );
    //   item["checked"] = checked;
    //   temp.push(item);
    // });
  
    // riskTypeList = [...temp];
    // riskTypemaster = [...temp];
  };
  const checkCFinFilterValuesOrNot = (field, value, exfilter) => {
    let flag = false;
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field && filter.value == value) {
            flag = true;
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field && innerFilter.value == value) {
                flag = true;
              }
            });
          }
        });
      }
    } catch (err) {
      return flag;
    }
    return flag;
  };
  const getImpactCellComponent = (props, products, impact) => {
    if (impact.impactType == "Qualitative") {
      return (
        <QualitativeImpactEditComponent
          {...props}
          onEditCell={numericCellEdit}
          stateData={products}
          addQualitativeImpact={AddQualitativeImpact}
          heatMapCount={heatmapCount}
        />
      );
    } else {
      return (
        <ImpactEditComponent
          {...props}
          onEditCell={numericCellEdit}
          stateData={products}
        />
      );
    }
  };

  const getImpactUnit = (impact, impactMasterTemp) => {
    if (impact.impactType == "Qualitative") {
      var impactTemp = impactMasterTemp.find(
        (item) => item.name + "_" + item.type == impact.fieldName
      );
      var res = impact.fieldName;
      if (impactTemp && impactTemp.name) {
        res = impactTemp.name + " / " + " (" + impactTemp.type + ")";
      }
      return res;
    } else {
      var impactTemp = impactMasterTemp.find(
        (item) => item.name + "_" + item.type == impact.fieldName
      );
      var res = impact.fieldName;
      if (impactTemp && impactTemp.name) {
        res =
          impactTemp.name +
          " / " +
          impactTemp.units +
          " (" +
          impactTemp.type +
          ")";
      }
      return res;
    }
  };

  const getSelectedColumn = (col) => {
    if (col != selectedColumn) {
      selectedColumn = col;
    }
  };

  const numericCellEdit = (dataItem, field, riskData) => {
    try {
      let filter = existingFilter ? existingFilter : [];
      const result = filterBy(riskData, filter);
      let impactMasterTemp = [];
      if (result && result.length > 0) {
        impactMasterTemp = result[0].impactResponse;
      }
      createDynamicCols(result, impactMasterTemp, filter);
      createDynamicDropdowns(result, filter);
      checkRisktypeSelections(filter);
      const dataValue = result.map((item) => ({
        ...item,
        inEdit:
          item.riskRegisterId === dataItem.riskRegisterId ? field : undefined,
      }));
      currentEditField = field;
      setData(dataValue);
      setEditField(field);
      // setCurrentChangedValue({...dataItem});
      currentChangedValue = { ...dataItem };
    } catch (err) {}
  };

  const stringToHash = (stringArr, cols) => {
    let hashArr = [];

    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      if (cols == "riskTypeNames") {
        valArr &&
          valArr.map((item1) => {
            let risktype = riskTypemaster.find((item) => item.name == item1);
            if (risktype) {
              hashArr.push(risktype.hashValue);
            }
          });
      }
    } else {
      if (stringArr != "") {
        if (cols == "riskTypeNames") {
          let risktype = riskTypemaster.find((item) => item.name == stringArr);
          if (risktype) {
            hashArr.push(risktype.hashValue);
          }
        }
      }
    }
    return hashArr.toString();
  };

  const convertStrToHash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    hash = Math.abs(hash).toString();
    return hash;
  };

  const changeLineChartWidth = (widgetId) => {
    if (selectedWgts) {
      setSelectedWgts("");
    } else {
      setSelectedWgts(widgetId);
    }
  };

  const removeFromHome = async (data) => {
    try {
      var req = {
        Enable: false,
        WidgetId: data.widgetId,
        UpdatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        UpdatedDate: new Date(),
      };
      setLoader(true);
      let response = await Api.WidgetHome(req);
      if (response.status === 200) {       
        toastr.success(response.message);
        console.log("req",req);

        getLetestWidgetForHome();
      } else {
        setLoader(false);
        toastr.error(response.message);
      }
      // console.clear();
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  };

  const onDragEnd = (event) => {
    if (event.target.state.isDragging) {
      setRecentChartData(event.newState);
      let reportIdList = [];
      event.newState.map((item) => {
        reportIdList.push(item.widgetId);
      });

      let req = {
        ReportId: reportIdList,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
      };
      Api.homeWidgetPersist(req);
    }
  };

  const onNavigate = (event) => {
    setRecentChartData(event.newState);
  };

  const AddQualitativeImpact = async (req) => {
    try {
      setLoader(true);
      var impact =
        (await req.impactResponse) &&
        req.impactResponse.find(
          (item) => item.name + "_" + item.type == req.inEdit
        );
      var request = {
        RiskId: req.riskRegisterId,
        QualitativeImpactId: impact ? impact.qualitativeImpactId : null,
        Qvalue: req[req.inEdit],
      };
      let response = await Api.addQualitativeImpact(request);
      if (response.status === 200) {
        await homeRisksByOwner();
        setLoader(false);
      } else {
        setLoader(false);
        toastr.success(response.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const itemChange = async (event) => {
    let changedValue;
    let dataValue;

    if (event.field === "riskTypeNames") {
      let value = event.value;
      changedValue = {
        ...event.dataItem,
        riskTypeNames: value,
        // riskTypeId: event.value.value,
      };
      let str = value ? value.toString() : "";
      let hash = await stringToHash(str, "riskTypeNames");
      dataValue = data.map((item) =>
        item.riskRegisterId === event.dataItem.riskRegisterId
          ? {
              ...item,
              riskTypeNames: hash,
              // riskTypeId: event.value.value,
            }
          : item
      );
    } else if (event.field === "isOpportunity") {
      changedValue = {
        ...event.dataItem,
        isOpportunityText: event.value.text,
        isOpportunityValue: event.value.value,
        isOpportunity: event.value.value,
      };
      dataValue = data.map((item) =>
        item.riskRegisterId === event.dataItem.riskRegisterId
          ? {
              ...item,
              [event.field]: event.value.text,
              isOpportunity: event.value.value,
            }
          : item
      );
    } else {
      changedValue = { ...event.dataItem, [event.field]: event.value };
      dataValue = data.map((item) =>
        item.riskRegisterId === event.dataItem.riskRegisterId
          ? { ...item, [event.field]: event.value }
          : item
      );

      if (isImpactColumns(editField)) {
        clearTimeout(event.blurTimeout);
        if (!event.preventExit) {
          event.blurTimeout = setTimeout(() => {
            exitEdit();
          });
        }
      }
    }
    currentChangedValue = changedValue;
    setData(dataValue);
    // setCurrentChangedValue((preState) => ({ ...preState, ...changedValue }));
    console.log("changedValue", currentChangedValue);
  };
  const isImpactColumns = (field) => {
    return RiskColumns.hasOwnProperty(field);
  };
  const sortChange = (event) => {
    let ttt = getProducts(event.sort);
    setSort(event.sort);
    setData(ttt);
  };
  const getProducts = (sort) => {
    return orderBy(data, sort);
  };

  const filterChangeExisting = async (e) => {
    if (e.nativeEvent.type == "submit") {
      let filterData = existingFilter ? existingFilter : [];
      let filter = e.filter ? e.filter.filters : [];
      // Get the field being filtered from the new filter
      const newFilterFields = new Set();
      if (filter && filter.length > 0) {
        filter.forEach(filterItem => {
          if (filterItem.filters) {
            filterItem.filters.forEach(innerFilter => {
              if (innerFilter.field) {
                newFilterFields.add(innerFilter.field);
              }
            });
          } else if (filterItem.field) {
            newFilterFields.add(filterItem.field);
          }
        });
      }

      // Remove any existing filters for the same fields
      let filteredExisting = existingFilter.filter(item => {
        // For filters with nested filters array
        if (item.filters) {
          return !item.filters.some(innerFilter =>
            innerFilter.field && newFilterFields.has(innerFilter.field)
          );
        }
        // For direct filters
        return !(item.field && newFilterFields.has(item.field));
      });

      // Combine filtered existing filters with new filters
      let combinedFilters = [...filteredExisting, ...filter];

      // Deduplicate the combined filters
      const uniqueFilters = new Set();
      const dedupedFilters = [];

      for (const filterItem of combinedFilters) {
        const filterStr = JSON.stringify(filterItem);
        if (!uniqueFilters.has(filterStr)) {
          uniqueFilters.add(filterStr);
          dedupedFilters.push(filterItem);
        }
      }

      existingFilterV1 = [...dedupedFilters];
      existingFilter = dedupedFilters;
      const result = filterBy(masterRiskList, dedupedFilters);
      let impactMasterTemp = [];
      if (result && result.length > 0) {
        impactMasterTemp = result[0].impactResponse;
        await createDynamicCols(result, impactMasterTemp, dedupedFilters);
        await createDynamicDropdowns(result, dedupedFilters);
      }
      await checkRisktypeSelections(dedupedFilters);
      setData(result);
      setDataState({
        sort: [],
        take: 10,
        skip: 0,
        group: [],
      });
      setFilter(e.filter);
    } else if (e.nativeEvent.type == "reset") {
      let exi = [];
      if (existingFilter) {
        let filterData = existingFilter;
        filterData.forEach((filter2) => {
          if (filter2.filters) {
            // Only add the filter if none of its inner filters match the selected column
            const hasMatchingInnerFilter = filter2.filters.some(
              innerFilter => innerFilter.field === selectedColumn);
            if (!hasMatchingInnerFilter) {
              exi.push(filter2);
            }
          } else {
            if (filter2.field != selectedColumn) {
              if (!exi.includes(filter2)) {
                exi.push(filter2);
              }
            }
          }
        });
      }

      existingFilter = exi;
      existingFilterV1 = [...exi];
      const result = filterBy(masterRiskList, exi);
      let impactMasterTemp = [];
      if (result && result.length > 0) {
        impactMasterTemp = result[0].impactResponse;
        await createDynamicCols(result, impactMasterTemp, exi);
        await createDynamicDropdowns(result, exi);
      }
      await checkRisktypeSelections(exi);
      setData(result);
      setDataState({
        sort: [],
        take: 10,
        skip: 0,
        group: [],
      });
      setFilter(e.filter);
    }
  };
  const filterChangeV = async (e, colname) => {
    try {
      let exi = [];

      let filterData = existingFilter ? existingFilter : existingFilterV1;
      filterData.map((filter2) => {
        if (filter2.filters) {
          filter2.filters.map((innerFilter) => {
            if (innerFilter.field != colname) {
              if (!exi.includes(filter2)) {
                exi.push(filter2);
              }
            }
          });
        } else {
          if (filter2.field != colname) {
            if (!exi.includes(filter2)) {
              exi.push(filter2);
            }
          }
        }
      });

      let filter = e ? e.filters : [];
      let temp = [];
      if (filter.length > 0) {
        temp = [
          {
            filters: filter,
            logic: "or",
          },
        ];
      }
      
      // Combine filtered existing filters with new filters
      let combinedFilters = [...exi, ...temp];
      
      // Deduplicate the combined filters
      const uniqueFilters = new Set();
      const dedupedFilters = [];
      
      for (const filterItem of combinedFilters) {
        const filterStr = JSON.stringify(filterItem);
        if (!uniqueFilters.has(filterStr)) {
          uniqueFilters.add(filterStr);
          dedupedFilters.push(filterItem);
        }
      }

      existingFilter = dedupedFilters;
      existingFilterV1 = [...dedupedFilters]; 
      const result = filterBy(masterRiskList, dedupedFilters);
      let impactMasterTemp = [];
      if (result && result.length > 0) {
        impactMasterTemp = result[0].impactResponse;
        await createDynamicCols(result, impactMasterTemp, dedupedFilters);
        await createDynamicDropdowns(result, dedupedFilters);
      }
      await checkRisktypeSelections(dedupedFilters);
      setData(result);
      setFilter({
        logic: "and",
        filters: dedupedFilters,
      });
      setDataState({
        sort: [],
        take: 10,
        skip: 0,
        group: [],
      });
    } catch (err) {}
  };
  const clearFilter = (e) => {
    let filter = e ? e : [];
    const result = filterBy(masterRiskList, filter);
    let impactMasterTemp = [];
    if (result && result.length > 0) {
      impactMasterTemp = result[0].impactResponse;
    }
    createDynamicCols(result, impactMasterTemp, filter);
    createDynamicDropdowns(result, filter);
    checkRisktypeSelections(filter);
    existingFilter = filter;
    setData(result);
    setFilter({
      logic: "and",
      filters: filter,
    });
  };

  const cellRender = (tdElement, cellProps) => {
    const dataItem = cellProps.dataItem;
    const cellField = cellProps.field;
    const inEditField = dataItem["inEdit"];

    const additionalProps =
      cellField && cellField === inEditField
        ? {
            ref: (td) => {
              const input = td && td.querySelector("input");
              const activeElement = document.activeElement;

              if (
                !input ||
                !activeElement ||
                input === activeElement ||
                !activeElement.contains(input)
              ) {
                return;
              }

              if (input.type === "checkbox") {
                input.focus();
              } else {
                input.select();
              }
            },
          }
        : {
            onClick: () => {
              enterEdit(dataItem, cellField);
            },
            onFocus: () => {
              enterEdit(dataItem, cellField);
            },
            tabIndex: "0",
          };
    if (tdElement && tdElement.props) {
      return React.cloneElement(
        tdElement,
        { ...tdElement.props, ...additionalProps },
        tdElement.props.children
      );
    } else {
      return <td></td>;
    }
  };

  const rowRender = (trElement) => {
    const trProps = {
      ...trElement.props,
      onMouseDown: (event) => {
        event.preventExit = true;
        clearTimeout(event.preventExitTimeout);
        event.preventExitTimeout = setTimeout(() => {
          event.preventExit = undefined;
        });
      },
      onBlur: (event) => {
        currentEditField = editField;
        if (
          !editField ||
          editField == "riskAlertStakeHolders" ||
          editField == "progress" ||
          editField == "riskTypeNames"
        ) {
          return;
        }

        clearTimeout(event.blurTimeout);
        if (!event.preventExit) {
          event.blurTimeout = setTimeout(() => {
            exitEdit();
          });
        }
        // dirty check
        let dirtData = masterRiskList.find(
          (item) => currentChangedValue.riskRegisterId == item.riskRegisterId
        );
        if (dirtData && currentChangedValue[editField] == dirtData[editField]) {
          exitEdit();
          return;
        }
        if (currentChangedValue.riskRegisterId) {
          if (!isImpactColumns(editField)) {
            var impact = currentChangedValue.impactResponse.filter(
              (item) => item.name + "_" + item.type == editField
            );

            if (impact.length > 0) {
              var req = {
                ProjectRiskId: currentChangedValue.riskRegisterId,
                ImpactId: impact[0].impactId,
                Value: parseFloat(currentChangedValue[editField]),
              };

              saveRiskImpact(req);
            }
          } else {
            if (
              editField != "frequency" &&
              editField != "name" &&
              editField != "riskTitle" &&
              editField != "cause" &&
              editField != "existingControl" &&
              // editField != "proximityDate" &&
              editField != "impactComments" &&
              editField != "alertDescription" &&
              editField != "riskAlertStakeHolders" &&
              editField != "progress"
            ) {
              updateRiskRegistor(currentChangedValue, true);
            }
          }
        } else {
          //Create
          var tmp = data;
          if (
            editField === "frequency" ||
            editField === "name" ||
            editField === "riskTitle" ||
            editField === "cause" ||
            editField === "existingControl" ||
            editField === "impactComments" ||
            editField === "alertDescription" ||
            editField === "riskAlertStakeHolders"
          ) {
            tmp[0][editField] =
              cellAddValue != "" ? cellAddValue : tmp[0][editField];
          }
          setData(tmp);
        }
      },
      onFocus: (event) => {
        clearTimeout(event.blurTimeout);
      },
    };
    return React.cloneElement(
      trElement,
      { ...trProps },
      trElement.props.children
    );
  };

  const saveRiskImpact = async (req) => {
    try {
      setLoader(true);
      let response = await Api.addImpactByRisk(req);
      if (response.status === 200) {
        // toastr.success(response.message);
        await homeRisksByOwner();
        setLoader(false);
      } else {
        setLoader(false);
        toastr.success(response.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const updateRiskRegisterDropDown = async (updateDate) => {
    await updateRiskRegistor(updateDate, true);
    exitEdit();
  };

  const riskRegistorUpdateValidation = async (Value) => {
    var flag = true;
    var msg = "";

    if (!Value.riskTitle || Value.riskTitle.trim() == "") {
      flag = false;
      msg = "The risk title";
    }

    if (!Value.isOpportunity) {
      flag = false;
      msg = msg + " and threat/opportunity";
    }

    if (!flag) {
      toastr.error(msg + " are required");
    }
    return flag;
  };
  const updateRiskRegistor = async (updateDate, flag) => {
    try {
      setLoader(true);
      if (flag) {
        var flag = await riskRegistorUpdateValidation(updateDate);

        if (!flag) {
          setLoader(false);
          return;
        }
      }

      if (updateDate.proximityDate) {
        updateDate.proximityDate = updateDate.proximityDate
          ? moment(updateDate.proximityDate).format("YYYY-MM-DD")
          : null;
      }

      let riskTypeIds = [];
      if (updateDate.riskTypeNames && currentEditField == "riskTypeNames") {
        let arr = updateDate.riskTypeNames.toString().trim().split(",");
        arr.map((id) => {
          let pid = riskTypeList.find((item) => item.text === id);
          if (pid) {
            riskTypeIds.push(pid.value);
          }
        });
      } else {
        let obj = masterRiskList.find(
          (item) => item.riskRegisterId == updateDate.riskRegisterId
        );
        if (obj) {
          riskTypeIds = obj.riskTypeIds;
        }
      }

      var requestParams = {
        riskRegisterId: updateDate.riskRegisterId,
        organizationUnitId: updateDate.organizationUnitId,
        number: updateDate.number,
        name: updateDate.name,
        isOpportunity: updateDate.isOpportunityText
          ? updateDate.isOpportunityText
          : updateDate.isOpportunity,
        cause: updateDate.cause,
        existingControl: updateDate.existingControl,
        frequency: updateDate.frequency ? parseInt(updateDate.frequency) : 0,
        impactComments: updateDate.impactComments,
        progress: editField == "progress" ? updateDate.progress : null,
        proximityDate: updateDate.proximityDate,
        alertDescription: updateDate.alertDescription,
        isClosed: typeof updateDate.isClosed == "boolean"
        ? updateDate.isClosed
        : updateDate.isClosed == "Closed"
        ? false
        : true,
        owner: updateDate.owner===" [blank]"?null:updateDate.owner,
        userId: updateDate.owner===" [blank]"?null:updateDate.ownerId,
        riskTitle: updateDate.riskTitle
          ? updateDate.riskTitle.slice(0, 30)
          : "",
        riskAlertStakeHolders:  processInput(updateDate.riskAlertStakeHolders),
        riskCustomField: [updateDate.riskCustomField],
        riskTypeIds: riskTypeIds,
        currentEditField: editField ? editField : currentEditField,
        
      };
      let response = await Api.updateRiskRegister(requestParams);
      if (response.status === 200) {
        // toastr.success(response.message);
        // setCurrentChangedValue({});
        var res = masterRiskList.map((obj) => {
          if (obj && obj.riskRegisterId == updateDate.riskRegisterId) {
            obj = response.riskReg;
          }
          return obj;
        });

        refreshRisk(res, "update", updateDate.riskRegisterId);

        currentChangedValue = {};
   
      } else {
        setLoader(false);
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  };

  const refreshRisk = async (response, flag, riskRegisterId) => {
    setLoader(true);
    await homeRisksByOwner();
    setLoader(false);
    // if (flag == "update") {
    //   await refreshRiskForUpdate(response, riskRegisterId);
    // } else {
    //   await homeRisksByOwner();
    //   setLoader(false);
    // }

    // clearFilter();
  };

  const refreshRiskForUpdate = async (riskRegister, riskRegisterId) => {
    try {
      if (riskRegister) {
        let impactMasterTemp = [];
        riskRegister.map((riskReg) => {
          if (expandedRowList.includes(riskReg.riskRegisterId)) {
            riskReg["expanded"] = true;
          } else {
            riskReg["expanded"] = false;
          }
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          if (
            riskReg.riskTypeNames &&
            riskReg.riskRegisterId === riskRegisterId
          ) {
            riskReg["riskTypeNamesExport"] = riskReg.riskTypeNames.toString();
            let hashArr = stringToHash(
              riskReg.riskTypeNames.toString(),
              "riskTypeNames"
            );
            riskReg["riskTypeNames"] = hashArr;
          }
          if (riskReg.isClosed==true||riskReg.isClosed== "Open") {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          impactMasterTemp = [...impactMasterTemp, ...riskReg.impactResponse];
        });

        impactMasterTemp = impactMasterTemp.filter(
          (ele, ind) =>
            ind ===
            impactMasterTemp.findIndex(
              (elem) =>
                elem.name === ele.name &&
                elem.impactType === ele.impactType &&
                elem.type === ele.type
            )
        );
        await createDynamicDropdowns(riskRegister, filter);
        await createDynamicCols(riskRegister, impactMasterTemp, filter);
        const result = filterBy(riskRegister, filter);
        await checkRisktypeSelections(filter);
        setData(result);
        masterRiskList = riskRegister;
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const getGridColum = (columns) => {
    let cellFieldName = columns.field;
    let width = columns.width;
    let isPrime = secureLocalStorage.getItem("isPrime") == true ? true : false;

    if (!cellFieldName) {
      return;
    }
    
     else if (cellFieldName == "riskTitle") {
      return (
        <GridColumn
          field="riskTitle"
          title="Risk Title *"
          width={width}
          resizable={false}
          reorderable={false}
          editable={true}
          locked={fixedGrid}
          orderIndex={0}
          //  fixedScroll={true}
          cell={(props) => (
            <RiskTitleCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              pageName={"home"}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={false}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={`${setClassName("riskTitle")} no-drag`}
        />
      );
    } 
    else if (cellFieldName == "isOpportunity") {
      return (
        <GridColumn
          // locked={fixedGrid}
          field="isOpportunity"
          title="T/O *"
          width={width}
          minResizableWidth={100}
          resizable={true}
          reorderable={true}
          // locked={fixedGrid}
          editable={true}
          cell={(props) => (
            <ThreatAndOpportunities
              {...props}
              dropDownData={opportunitiesList}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("isOpportunity")}
        />
      );
    } else if (cellFieldName == "name") {
      return (
        <GridColumn
          // locked={true}

          field="name"
          title="Risk Description"
          width={width}
          resizable={true}
          reorderable={true}
          editable={true}
          // locked={fixedGrid}
          cell={(props) => (
            <RiskDescriptionCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={false}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("name")}
        />
      );
    } else if (cellFieldName == "riskTypeNames") {
      getsortedrisklist();
      return (
        <GridColumn
          field="riskTypeNames"
          title="Risk Type"
          width={width}
          editable={true}
          resizable={true}
          reorderable={true}
          cell={(props) => (
            <DropDownCell
              {...props}
              dropDownData={riskTypeList}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <SearchMenu
              {...props}
              existingFilter={existingFilter}
              data={riskTypeList}
              filterChangeV={filterChangeV}
              clearFilter={clearFilter}
            />
          )}
          headerClassName={setClassName("riskTypeNames")}
        />
      );
    } else if (cellFieldName == "customFields") {
      //CF cell
      return dropdownColumns;
    } else if (cellFieldName == "mitigationCount") {
      return (
        <GridColumn
          field="mitigationCount"
          title="Action Count"
          width={width}
          resizable={true}
          reorderable={true}
          filter={"numeric"}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("mitigationCount")}
        />
      );
    } else if (cellFieldName == "cause") {
      return (
        <GridColumn
          field="cause"
          title="Cause"
          width={width}
          resizable={true}
          reorderable={true}
          cell={(props) => (
            <RiskCauseCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={false}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("cause")}
        />
      );
    } else if (cellFieldName == "impactComments") {
      return (
        <GridColumn
          field="impactComments"
          title="Consequences"
          width={width}
          resizable={true}
          reorderable={true}
          cell={(props) => (
            <RiskCommonCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={false}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("impactComments")}
        />
      );
    } else if (cellFieldName == "existingControl") {
      return (
        <GridColumn
          field="existingControl"
          title="Existing Control"
          width={width}
          resizable={true}
          reorderable={true}
          cell={(props) => (
            <ExistingControlCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={false}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("existingControl")}
        />
      );
    } else if (cellFieldName == "progress") {
      return (
        <GridColumn
          field="progress"
          title="Progress Status"
          width={width}
          resizable={true}
          reorderable={true}
          cell={(props) => (
            <RiskProgressPopup
              {...props}
              onEditCell={enterEdit}
              exitEdit={exitEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("progress")}
        />
      );
    } else if (cellFieldName == "frequency") {
      return (
        <GridColumn
          field="frequency"
          title="Pre-Probability (%)"
          width={width}
          resizable={true}
          reorderable={true}
          filter={"numeric"}
          cell={(props) => (
            <RiskFrequencyComponent
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={false}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("frequency")}
        />
      );
    } else if (cellFieldName == "reductionProbability") {
      return (
        <GridColumn
          field="reductionProbability"
          title="Post-Probability (%)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          cell={(props) => (
            <td>
              <span className="yellowCell">
                {props.dataItem.reductionProbability
                  ? props.dataItem.reductionProbability
                  : 0}
              </span>
            </td>
          )}
          filter={"numeric"}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("reductionProbability")}
        />
      );
    } else if (cellFieldName == "currentProbability") {
      return (
        <GridColumn
          field="currentProbability"
          title="Current-Probability (%)"
          width={width}
          resizable={true}
          reorderable={true}
          filter={"numeric"}
          editable={false}
          cell={(props) => (
            <td>
              <span className="turquoiseBlue">
                {props.dataItem.currentProbability}
              </span>
            </td>
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("currentProbability")}
        />
      );
    } else if (cellFieldName == "pre") {
      return (
        <GridColumn
          field="pre"
          title="pre"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          sortable={false}
          cell={(props) => (
            <PrePostComponenant
              {...props}
              HeatMapConfigDataOpportunity={HeatMapConfigDataOpportunity}
              HeatMapConfigDataThreat={HeatMapConfigDataThreat}
              dynamicHeatmapProbabilityRange={dynamicHeatmapProbabilityRange}
            />
          )}
        />
      );
    }
    else if (cellFieldName == "current") {
      return (
        <GridColumn
          field="current"
          title="current"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          sortable={false}
          cell={(props) => (
            <PrePostComponenant
              {...props}
              HeatMapConfigDataOpportunity={HeatMapConfigDataOpportunity}
              HeatMapConfigDataThreat={HeatMapConfigDataThreat}
              dynamicHeatmapProbabilityRange={dynamicHeatmapProbabilityRange}
            />
          )}
        />
      );
    } else if (cellFieldName == "post") {
      return (
        <GridColumn
          field="post"
          title="post"
          width={width}
          resizable={true}
          reorderable={true}
          sortable={false}
          editable={false}
          cell={(props) => (
            <PrePostComponenant
              {...props}
              HeatMapConfigDataOpportunity={HeatMapConfigDataOpportunity}
              HeatMapConfigDataThreat={HeatMapConfigDataThreat}
              dynamicHeatmapProbabilityRange={dynamicHeatmapProbabilityRange}
            />
          )}
        />
      );
    } 
    // else if (cellFieldName == "overAll") {
    //   return (
    //     <GridColumn
    //       field="overAll"
    //       title="OverAll Impact"
    //       width={width}
    //       resizable={true}
    //       reorderable={true}
    //       sortable={false}
    //       editable={false}
    //       cell={(props) => <OverallComponenant {...props} />}
    //     />
    //   );
    // }
     else if (cellFieldName == "preWeightedRiskScore" && isPrime === true&&isPrimeWorkstreams==true) {
      return (
        <GridColumn
          field="preWeightedRiskScore"
          title="Prime Risk Score (Pre)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          headerClassName={setClassName("preWeightedRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          cell={(props) => (
            <td>
              <span>
                {props.dataItem.isPrimeWorkstreams&&secureLocalStorage.getItem("isPrime")==true?props.dataItem.preWeightedRiskScore:""}
              </span>
            </td>
          )}
        />
      );
    } else if (
      cellFieldName == "currentWeightedRiskScore" &&
      isPrime === true&&isPrimeWorkstreams==true
    ) {
      return (
        <GridColumn
          field="currentWeightedRiskScore"
          title="Prime Risk Score (Current)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          headerClassName={setClassName("currentWeightedRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          cell={(props) => (
            <td>
              <span className="turquoiseBlue">
              {props.dataItem.isPrimeWorkstreams&&secureLocalStorage.getItem("isPrime")==true?props.dataItem.currentWeightedRiskScore:""}
              </span>
            </td>
          )}
        />
      );
    } else if (cellFieldName == "postWeightedRiskScore" && isPrime === true&&isPrimeWorkstreams==true) {
      return (
        <GridColumn
          field="postWeightedRiskScore"
          title="Prime Risk Score (Post)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          headerClassName={setClassName("postWeightedRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          cell={(props) => (
            <td>
              <span className="yellowCell">
              {props.dataItem.isPrimeWorkstreams&&secureLocalStorage.getItem("isPrime")==true?props.dataItem.postWeightedRiskScore:""}
              </span>
            </td>
          )}
        />
      );
    } else if (cellFieldName == "preRiskScore") {
      return (
        <GridColumn
          field="preRiskScore"
          title="Risk Score (Pre)"
          headerClassName={setClassName("preRiskScore")}
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
        />
      );
    } else if (cellFieldName == "currentRiskScore" ) {
      return (
        <GridColumn
          field="currentRiskScore"
          title="Risk Score (Current)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          headerClassName={setClassName("currentRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          cell={(props) => (
            <td>
              <span className="turquoiseBlue">
                {props.dataItem.currentRiskScore}
              </span>
            </td>
          )}
        />
      );
    } else if (cellFieldName == "postRiskScore") {
      return (
        <GridColumn
          field="postRiskScore"
          title="Risk Score (Post)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          headerClassName={setClassName("postRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          cell={(props) => (
            <td>
              <span className="yellowCell">{props.dataItem.postRiskScore}</span>
            </td>
          )}
        />
      );
    } else if (cellFieldName == "impactFields") {
      // impact cells
      return impactColumns;
    } else if (cellFieldName == "proximityDate") {
      return (
        <GridColumn
          field="proximityDate"
          title="Proximity Alert Date"
          width={width}
          // editor="date"
          resizable={true}
          reorderable={true}
          filter={"date"}
          // format="{0:dd-MMM-yyyy}"

          cell={(props) => (
            <RiskProximityDateCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              handleCellAddValue={handleCellAddValue}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("proximityDate")}
        />
      );
    } else if (cellFieldName == "alertDescription") {
      return (
        <GridColumn
          field="alertDescription"
          title="Alert Description"
          width={width}
          resizable={true}
          reorderable={true}
          cell={(props) => (
            <RiskCommonCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={false}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("alertDescription")}
        />
      );
    } else if (cellFieldName == "riskAlertStakeHolders") {
      return (
        <GridColumn
          field="riskAlertStakeHolders"
          title="Alert StakeHolders"
          width={width}
          resizable={true}
          reorderable={true}
          cell={(props) => (
            <RiskAlertStackHolderComponent
              {...props}
              dropDownData={stackeHolderList}
              onEditCell={enterEdit}
              exitEdit={exitEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("riskAlertStakeHolders")}
        />
      );
    } else if (cellFieldName == "owner") {
      return (
        <GridColumn
          field="owner"
          width={width}
          title="Owner"
          resizable={true}
          reorderable={true}
          cell={(props) => (
            <OwnerDropDownCell
              {...props}
              dropDownData={ownerListForRisk}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("owner")}
        />
      );
    }
    else if (cellFieldName == "createdDate") {
      return (
        <GridColumn
          field="createdDate"
          title="created Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("createdDate")}
        />
      );
    } 
     else if (cellFieldName == "createdby") {
    return (
      <GridColumn
        field="createdByName"
        title="created By"
        width={width}
        resizable={true}
        reorderable={true}
        editable={false}
        // locked={fixedGrid}
        columnMenu={(props) => (
          <ColumnMenuCheckboxFilter
            {...props}
            data={data}
            getSelectedColumn={getSelectedColumn}
          />
        )}
        headerClassName={setClassName("createdByName")}
      />
    );
  }
  else if (cellFieldName == "updatedDate") {
      return (
        <GridColumn
          field="updatedDate"
          title="Updated Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("updatedDate")}
        />
      );
    } 
     else if (cellFieldName == "updatedBy") {
    return (
      <GridColumn
        field="updatedBy"
        title="Updated By"
        width={width}
        resizable={true}
        reorderable={true}
        editable={false}
        // locked={fixedGrid}
        columnMenu={(props) => (
          <ColumnMenuCheckboxFilter
            {...props}
            data={data}
            getSelectedColumn={getSelectedColumn}
          />
        )}
        headerClassName={setClassName("updatedBy")}
      />
    );
  }
     else if (cellFieldName == "isClosed") {
      return (
        <GridColumn
          field="isClosed"
          title="Status"
          width={width}
          resizable={true}
          reorderable={true}
          // editor="boolean"
          cell={(props) => (
            <StatusComponent
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          
          headerClassName={setClassName("isClosed")}
        />
      );
    } else if (cellFieldName == "closedDate") {
      return (
        <GridColumn
          field="closedDate"
          title="Closed Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("closedDate")}
        />
      );
    } else {
      let cf = dropdownColumns.find(
        (item) => cellFieldName === item.props.field
      );
      if (cf) {
        // Clone the object and update width
        let newCf = {
          ...cf,
          props: {
            ...cf.props,
            width: width,
          },
        };

        return newCf;
      } else {
        let imp = impactColumns.find(
          (impact) => cellFieldName === impact.props.field
        );
        if (imp) {
          // Clone the object and update width
        let newCf = {
          ...imp,
          props: {
            ...imp.props,
            width: width,
          },
        };

        return newCf;
        }
      }
    }
  };
  const actionButtonsForViewOnly = (event) => {
    let eventData = event;
    return (
      <td  style={{ left: "42px", right: "0px" }}>
        <ul className="actionIcon">
          <li>
            <a
              title="View"
              className="greenbtn"
              onClick={() => editFormView(eventData.dataItem)}
            >
              <img src={Images.VIEW} width="12" alt="More" />
            </a>
          </li>
          <li>
            <a
              title="Documents"
              className={
                eventData.dataItem.documentCount == 0
                  ? "greenbtn roundedBtn icon"
                  : "bluebtn roundedBtn icon"
              }
            >

              <NavLink
                title="Document"
                className={
                  eventData.dataItem.documentCount == 0
                    ? "greenbtn icon"
                    : "bluebtn icon"
                }
                to={`/${secureLocalStorage.getItem(
                  "loggedClient"
                )}/${secureLocalStorage.getItem(
                  "tenantKey"
                )}/home/documents/riskregisterdocs/${
                  eventData.dataItem.riskRegisterId
                }`}
              >
                <img
                  src={
                    eventData.dataItem.documentCount == 0
                      ? Images.DOCUMENT
                      : Images.DOCUMENTBLUE
                  }
                  width="12"
                  alt="Document"
                />
              </NavLink>
            </a>
          </li>
        </ul>
      </td>
    );
  };
  
  const editFormView = (dataItem) => {
    try {
      setFormEditFlag(true);
      setFormData(dataItem);
      setShowFormView(true);
      // let orgUnit=organisationUnitList.f
      let orgUnit={};
      mapTree(organisationUnitListForRisk, "children", (item) => {
        if(item.unitId===dataItem.organizationUnitId){
          orgUnit=item;
        }
        return item;
      });
      setOrgUnit(orgUnit);
      if(myRef&&myRef.current){
        myRef.current.loadEditmode(dataItem);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const enterEdit = (dataItem, field) => {
    try {
      const dataValue = data.map((item) => ({
        ...item,
        inEdit:
          item.riskRegisterId === dataItem.riskRegisterId ? field : undefined,
      }));
      currentEditField = field;
      setData(dataValue);
      setEditField(field);
      // setCurrentChangedValue(dataItem);
      currentChangedValue = { ...dataItem };
    } catch (err) {}
  };

  const customCellEdit = (dataItem, field, riskData) => {
    try {
      let filter = existingFilter ? existingFilter : [];
      const result = filterBy(riskData, filter);
      let impactMasterTemp = [];
      if (result && result.length > 0) {
        impactMasterTemp = result[0].impactResponse;
      }
      createDynamicCols(result, impactMasterTemp, filter);
      createDynamicDropdowns(result, filter);
      checkRisktypeSelections(filter);
      const dataValue = result.map((item) => ({
        ...item,
        inEdit:
          item.riskRegisterId === dataItem.riskRegisterId ? field : undefined,
      }));
      currentEditField = field;
      setData(dataValue);
      setEditField(field);
      currentChangedValue = { ...dataItem };
    } catch (err) {}
  };

  const exitEdit = () => {
    const dataValue = data.map((item) => ({ ...item, inEdit: undefined }));
    currentEditField = undefined;
    setData(dataValue);
    setEditField(undefined);
  };

  const refreshAction = async () => {
    setLoader(true);
    await homeActionsByOwner();
    setLoader(false);
  };
const refreshExpandAction=(per)=>{
  setPersistenceActionExpandGrid(per);
}
const refreshExpandActivity=(per)=>{
  setPersistenceActivityExpandGrid(per);
}
  const onColumnReorder = async (event) => {
    try {
      let req = {
        RiskDetails: JSON.stringify(event.target.columnResize.columns),
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
      };
      await Api.persistHomeRisks(req);
    } catch (err) {
      console.log(err);
    }
  };

  const onColumnResize = async (event) => {
    if (event.end) {
      try {
        let req = {
          RiskDetails: JSON.stringify(event.target.columnResize.columns),
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
        };
        await Api.persistHomeRisks(req);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const getHomeRiskPersistance = async () => {
    try {
      let req = {
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getHomeRiskPersistance(req);
      if (
        response.status == 200 &&
        response.homeRiskRegisterPersist &&
        response.homeRiskRegisterPersist.riskDetails
      ) {
        let persis = JSON.parse(response.homeRiskRegisterPersist.riskDetails);
        setPersistenceRiskGrid(persis);
      } else {
        setPersistenceRiskGrid(PersistenceRiskHome);
      }
    } catch (err) {
      console.log(err);
      setPersistenceRiskGrid(PersistenceRiskHome);
    }
  };

  const getHomePersistance = async () => {
    try {
      let req = {
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getHomePersistance(req);
      if (
        response.status == 200 &&
        response.homeRiskActionPersist &&
        response.homeRiskActionPersist.actionDetails
      ) {
        let persis = JSON.parse(response.homeRiskActionPersist.actionDetails);
        setPersistenceActionGrid(persis);
      } else {
        setPersistenceActionGrid(ActionPersistenceHome);
      }
    } catch (err) {
      console.log(err);
      setPersistenceActionGrid(ActionPersistenceHome);
    }
  };
  const [persistenceTaskGrid, setPersistenceTaskGrid] = React.useState(PersistenceTasks);
  const [persistenceTaskActionGrid, setPersistenceTaskActionGrid] = React.useState(PersistenceTaskAction);
  const [persistenceActionExpandGrid, setPersistenceActionExpandGrid] = React.useState(ActionPersistenceHome);
  const [persistenceActivityExpandGrid, setPersistenceActivityExpandGrid] = React.useState(PersistenceTaskAction);

  const getTaskPersistence = async (flag) => {
    try {
      let req = {
        WorkstreamId: null,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        "screenName": flag,
      };
      let response = await Api.getTaskPersistence(req);
      if (
        response.status == 200 &&
        response.taskPersistenceResponse &&
        response.taskPersistenceResponse.persistenceDetails
      ) {


        if(flag==="HomeTask"){
          let persis = JSON.parse(response.taskPersistenceResponse.persistenceDetails);
          setPersistenceTaskGrid(persis);
        }else if(flag==="HomeTaskAction"){
          let persis = JSON.parse(response.taskPersistenceResponse.persistenceDetails);
          setPersistenceTaskActionGrid(persis);
        }else if(flag==="ACTION-EXPAND-HOME"){
          let persis = JSON.parse(response.taskPersistenceResponse.persistenceDetails);
          setPersistenceActionExpandGrid(persis);
        }else if(flag==="ACTIVITY-EXPAND-HOME"){
          let persis = JSON.parse(response.taskPersistenceResponse.persistenceDetails);
          setPersistenceActivityExpandGrid(persis);
        }
      } 
    } catch (err) {
      console.log(err);
    }
  };
  const [resetPopup, setResetPopup] = React.useState(false);
  const [riskOrAction, setRiskOrAction] = React.useState("");
  const [resetFlag, setResetFlag] = React.useState("");

  const resetPopupOpen = (flag) => {
    setResetPopup(true);
    setRiskOrAction(flag);
  };
  const resetPopupClose = () => {
    setResetPopup(false);
    setRiskOrAction(null);
  };
  const resetPersistence = async () => {
    try {
      setResetFlag("RISK");
      setLoader(true);
      let req = {
        RiskDetails: undefined,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
      };
      let response = await Api.persistHomeRisks(req);
      if (response.status == 200) {
              setPersistenceRiskGrid(PersistenceRiskHome);
              resetPopupClose();
              setResetFlag("");
              setLoader(false);
        // setTimeout(() => {
        //   window.location.reload(false);
        // }, 3000);
      } else {
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
    }
  };
  const resetActivityPersistence= async () => {
    try {
      // setTaskActionsList([]);
      setResetFlag("ACTIVITY");
      setLoader(true);
      let req = {
        persistenceDetails: undefined,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
        "screenName": "HomeTaskAction"
      };
      let response = await Api.addTaskPersistence(req);
      if (response.status == 200) {
        setPersistenceTaskActionGrid(PersistenceTaskAction)
        resetPopupClose();
        setResetFlag("");
        setLoader(false);
        if(myrecentactivity&&myrecentactivity.current){
          myrecentactivity.current.init();
        }
      } else {
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
    }
  };
const resetTaskPersistence = async () => {
  try {
    setResetFlag("TASK");
    setLoader(true);
    let req = {
      persistenceDetails: undefined,
      UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
      CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      CreatedDate: new Date(),
      updatedDate: new Date(),
      "screenName": "HomeTask"
    };
    let response = await Api.addTaskPersistence(req);
    if (response.status == 200) {
      setPersistenceTaskGrid(PersistenceTasks);
      resetPopupClose();
              setResetFlag("");
              setLoader(false);
    } else {
      setLoader(false);
    }
  } catch (err) {
    setLoader(false);
    console.log(err);
  }
};
  const resetActionPersistence = async () => {
    try {
      setResetFlag("ACTION");
      setLoader(true);
      let req = {
        ActionDetails: undefined,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
      };
      let response = await Api.persistHomeAction(req);
      if (response.status == 200) {
        setPersistenceActionGrid(ActionPersistenceHome);
        resetPopupClose();
              setResetFlag("");
              setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
    }
  };
  const resetExpandActionPersistence = async () => {
    try {
      setResetFlag("ACTION-EXPAND-HOME");
      setLoader(true);
      let req = {
        persistenceDetails: undefined,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
        "screenName": "ACTION-EXPAND-HOME"
      };
      let response = await Api.addTaskPersistence(req);
      if (response.status == 200) {
        setPersistenceActionExpandGrid(ActionPersistenceHome);
        resetPopupClose();
        setResetFlag("");
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
    }
  };
    const resetExpandActivityPersistence = async () => {
    try {
      setResetFlag("ACTIVITY-EXPAND-HOME");
      setLoader(true);
      let req = {
        persistenceDetails: undefined,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
        "screenName": "ACTIVITY-EXPAND-HOME"
      };
      let response = await Api.addTaskPersistence(req);
      if (response.status == 200) {
        setPersistenceActivityExpandGrid(PersistenceTaskAction);
        resetPopupClose();
        setResetFlag("");
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
    }
  };
  const openRiskFormView=()=>{
    setShowFormView(true);
  }

  const closeRiskFormView=()=>{
    setShowFormView(false);
    setFormEditFlag(false);
    setFormData({});
  }

  const expandCell = (props) => (
    <GridExpandComponent {...props} expandChange={expandChange} />
  );

  const expandChange = React.useCallback(
    (dataItem) => {
      dataItem.expanded = !dataItem.expanded;
      let expandRow = expandedRowList ? expandedRowList : [];

      //scroll reset
      document
        .getElementById("DataGrid")
        .getElementsByClassName("k-grid-content")[0].scrollLeft = 0;
      //
      if (expandRow.includes(dataItem.riskRegisterId)) {
        let expanedState = expandedRowList;
        let indexValue = expanedState.findIndex(
          (item) => dataItem.riskRegisterId === item
        );
        expanedState.splice(indexValue, 1);
        expandRow = expanedState;
      } else {
        expandRow.push(dataItem.riskRegisterId);
      }
      data.map((riskReg) => {
        if (riskReg.riskRegisterId === dataItem.riskRegisterId) {
          riskReg["expanded"] = dataItem.expanded;
        }
      });
      let orgUnit={};
      mapTree(organisationUnitListForRisk, "children", (item) => {
        if(item.unitId===dataItem.organizationUnitId){
          orgUnit=item;
        }
        return item;
      });
      
      setOrgUnit(orgUnit);
      setExpandRowList(expandRow);
      setData([...data]);
      masterRiskList = [...data];
    },
    [data, setData, expandedRowList, setExpandRowList]
  );


  const addRiskDataFromForm=(flag,formData)=>{
    try{
      if(flag==="UPDATE"){
        var res = masterRiskList.map((obj) => {
          if (obj && obj.riskRegisterId == formData.riskRegisterId) {
  
            obj = formData;
          }
          return obj;
        });
        refreshRisk(res, "update", formData.riskRegisterId);
      }else if(flag==="ADD"){
         masterRiskList.unshift(formData);
        refreshRisk(masterRiskList, "update", formData.riskRegisterId);
        //setCurrentChangedValue({});
      }
      
    }catch(err){
      console.error(err);
    }
  }
  const getuserrole = () => {
    try {
      let loginUsername = secureLocalStorage.getItem("userName");
      let loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
      let userdetails = TenantUsers.find((e) => e.userId === loginUserId);
      var loginuser = {
        value: secureLocalStorage.getItem("loginUserId"),
        text: loginUsername,
      };
      var tempUserList = [loginuser].concat(userList);
      userListdropdown = tempUserList;
      if (
        userdetails?.isTenantAdmin === true ||
        userdetails?.role === "Tenant" ||
        userdetails?.role === "Project Admin"
      ) {
        Enableselectuser = true;
      } else {
        Enableselectuser = false;
      }
    } catch (err) {
      console.error(err);
    }
  };
  const handleRiskOwner=async (e)=>{
    setRiskOwnerByTenant(e.target.value);
    setLoader(true);
    await homeRisksByOwner(e.target.value.value,"ByDropdown");
    setLoader(false);
  }

  const handleActionOwner=async (e)=>{
    setActionOwnerByTenant(e.target.value);
    setLoader(true);
    await homeActionsByOwner(e.target.value.value,"ByDropdown");
    setLoader(false);
  }
  const handleSubTasklist = async (e)=>{
    setTaskActionsOwnerByTenant(e.target.value)
    setLoader(true);
    await homeTaskActionsByOwner(e.target.value.value,"ByDropdown");
    setLoader(false);
  }
  const handleTasklist = async (e)=>{
    setTaskOwnerByTenant(e.target.value);
  }
  const handlereport=(e)=>{
    setvalue(e.target.value)
  }
  return (
    <div className="HomeContainer">
      {loader ? (
        <span className="MatTableSpinner">
          <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
        </span>
      ) : null}
      {/* {progress < 100 && (
        <div className="progressBar">
          <div className="backdrop"></div>
          <div class="progress">
            <div
              class="progress-bar bg-success progress-bar-striped active progress-bar-animated"
              role="progressbar"
              aria-valuenow="40"
              aria-valuemin="0"
              aria-valuemax="100"
              style={{ width: `${progress}%` }}
            >
              {progress}% Completed
            </div>
          </div>
        </div>
      )} */}

      {/* Risk Form View */}
      <RiskRegisterFormView
        formEditFlag={formEditFlag}
        formData={formData}
        showFormView={showFormView}
        orgUnit={orgUnit}
        closeRiskFormView={closeRiskFormView}
        addRiskDataFromForm={addRiskDataFromForm}
        dropDownData={stackeHolderList}
        riskTypeList={riskTypeList}
        ownerListForRisk={ownerListForRisk}
        heatMapCount={heatmapCount}
        customFieldsData={
          customFieldsData.length > 0 ? customFieldsData : customFieldsDataState
        }
        {...props}
        ref={myRef}
      />
      <div className="appCont">
        <div className="mainWrapper">
          <div className="dashboardCont HomeConts">
            <div className="dbGrids">
              <div className="dbRow">
                <div className="dbCol rBox">
                  <div className="gBox">
                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.ASSESSMENT}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Total Risks</p>
                        <h4>
                          {riskCount.totalRiskCount
                            ? riskCount.totalRiskCount
                            : 0}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex">
                      <div className="iconBox">
                        <img src={Images.WARNING} width="16" alt="Dashboard" />
                      </div>
                      <div className="dbConfigData">
                        <p>Open Risks</p>
                        <h4>
                          {riskCount.openRiskCount
                            ? riskCount.openRiskCount
                            : 0}{" "}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.CHECKCIRCLE}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Closed Risks</p>
                        <h4>
                          {riskCount.closedRiskCount
                            ? riskCount.closedRiskCount
                            : 0}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.ASSESSMENT}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Total Actions</p>
                        <h4>
                          {actionCount.totalActionCount
                            ? actionCount.totalActionCount
                            : 0}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex">
                      <div className="iconBox">
                        <img src={Images.WARNING} width="16" alt="Dashboard" />
                      </div>
                      <div className="dbConfigData">
                        <p>Open Actions</p>
                        <h4>
                          {actionCount.openActionCount
                            ? actionCount.openActionCount
                            : 0}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.CLOSEDRISK}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>

                      <div className="dbConfigData">
                        <p>Closed Actions</p>
                        <h4>
                          {actionCount.closedActionCount
                            ? actionCount.closedActionCount
                            : 0}
                        </h4>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className="iconBox">
                        <img src={Images.VIEWDATA} width="16" alt="Dashboard" />
                      </div>

                      <div className="dbConfigData">
                        <p>Original Overdue Actions</p>
                        <h4>
                          {actionCount.overdueActionCount
                            ? actionCount.overdueActionCount
                            : 0}
                        </h4>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className="iconBox">
                        <img src={Images.VIEWDATA} width="16" alt="Dashboard" />
                      </div>

                      <div className="dbConfigData">
                        <p>Projected Overdue Actions</p>
                        <h4>
                          {actionCount.projectedOverdueActionCount
                            ? actionCount.projectedOverdueActionCount
                            : 0}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex">
                      {/* ----New--- */}
                      <div className="iconBox">
                        <img
                          src={Images.UNAPPROVE}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Unapproved Action Cost</p>
                        <h4>
                          {secureLocalStorage.getItem("currency")}
                          {aggregationsCount.unApprovedRiskBudget
                            ? formatNumber(
                                aggregationsCount.unApprovedRiskBudget,
                                "##,#"
                              )
                            : 0}
                        </h4>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.CHECKCIRCLE}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Approved Action Cost</p>
                        <h4>
                          {secureLocalStorage.getItem("currency")}
                          {aggregationsCount.riskBudgetApproved
                            ? formatNumber(
                                aggregationsCount.riskBudgetApproved,
                                "##,#"
                              )
                            : 0}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Task KPI  start*/}
            {secureLocalStorage.getItem("isTasksModuleEnabled") === true && (
              <div className="dbGrids">
                <div className="dbRow">
                  <div className="dbCol rBox">
                    <div className="gBox">
                      <div className="d-flex">
                        <div className="iconBox">
                          <img
                            src={Images.ASSESSMENT}
                            width="16"
                            alt="Dashboard"
                          />
                        </div>
                        <div className="dbConfigData">
                          <p>Total Tasks</p>
                          <h4>
                            {taskMetrics.totalTasksCount
                              ? taskMetrics.totalTasksCount
                              : 0}
                          </h4>
                        </div>
                      </div>

                      <div className="d-flex">
                        <div className="iconBox">
                          <img
                            src={Images.WARNING}
                            width="16"
                            alt="Dashboard"
                          />
                        </div>
                        <div className="dbConfigData">
                          <p>Open Tasks</p>
                          <h4>
                            {taskMetrics.openTasksCount
                              ? taskMetrics.openTasksCount
                              : 0}{" "}
                          </h4>
                        </div>
                      </div>

                      <div className="d-flex">
                        <div className="iconBox">
                          <img
                            src={Images.CHECKCIRCLE}
                            width="16"
                            alt="Dashboard"
                          />
                        </div>
                        <div className="dbConfigData">
                          <p>Closed Tasks</p>
                          <h4>
                            {taskMetrics.closedTasksCount
                              ? taskMetrics.closedTasksCount
                              : 0}
                          </h4>
                        </div>
                      </div>

                      <div className="d-flex">
                        <div className="iconBox">
                          <img
                            src={Images.ASSESSMENT}
                            width="16"
                            alt="Dashboard"
                          />
                        </div>
                        <div className="dbConfigData">
                          <p>Total Activities</p>
                          <h4>
                            {taskActionMetrics.totalTaskActionCount
                              ? taskActionMetrics.totalTaskActionCount
                              : 0}
                          </h4>
                        </div>
                      </div>

                      <div className="d-flex">
                        <div className="iconBox">
                          <img
                            src={Images.WARNING}
                            width="16"
                            alt="Dashboard"
                          />
                        </div>
                        <div className="dbConfigData">
                          <p>Open Activity</p>
                          <h4>
                            {taskActionMetrics.openTaskActionCount
                              ? taskActionMetrics.openTaskActionCount
                              : 0}
                          </h4>
                        </div>
                      </div>

                      <div className="d-flex">
                        <div className="iconBox">
                          <img
                            src={Images.CLOSEDRISK}
                            width="16"
                            alt="Dashboard"
                          />
                        </div>

                        <div className="dbConfigData">
                          <p>Closed Activity</p>
                          <h4>
                            {taskActionMetrics.closedTaskActionCount
                              ? taskActionMetrics.closedTaskActionCount
                              : 0}
                          </h4>
                        </div>
                      </div>
                      {/* New Keys*/}
                      <div className="d-flex">
                        <div className="iconBox">
                          <img
                            src={Images.UNAPPROVE}
                            width="16"
                            alt="Dashboard"
                          />
                        </div>
                        <div className="dbConfigData">
                          <p>Total Activities Cost</p>
                          <h4>
                            {secureLocalStorage.getItem("currency")}
                            {taskActionMetrics.totalTaskActionCost
                              ? formatNumber(
                                  taskActionMetrics.totalTaskActionCost,
                                  "##,#"
                                )
                              : 0}
                          </h4>
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="iconBox">
                          <img
                            src={Images.CHECKCIRCLE}
                            width="16"
                            alt="Dashboard"
                          />
                        </div>
                        <div className="dbConfigData">
                          <p>Approved Activities Cost</p>

                          <h4>
                            {secureLocalStorage.getItem("currency")}
                            {taskActionMetrics.approvedTaskActionCost
                              ? formatNumber(
                                  taskActionMetrics.approvedTaskActionCost,
                                  "##,#"
                                )
                              : 0}
                          </h4>
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="iconBox">
                          <img
                            src={Images.DASHBOARDICON}
                            width="16"
                            alt="Dashboard"
                          />
                        </div>
                        <div className="dbConfigData">
                          <p>Unapproved Activities Effort</p>
                          <h4>
                            {taskActionMetrics.unApprovedTaskActionEffort
                              ? taskActionMetrics.unApprovedTaskActionEffort
                              : 0}
                          </h4>
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="iconBox">
                          <img
                            src={Images.DASHBOARDICON}
                            width="16"
                            alt="Dashboard"
                          />
                        </div>
                        <div className="dbConfigData">
                          <p>Approved Activities Effort</p>
                          <h4>
                            {taskActionMetrics.approvedTaskActionEffort
                              ? taskActionMetrics.approvedTaskActionEffort
                              : 0}
                          </h4>
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="iconBox">
                          <img
                            src={Images.VIEWDATA}
                            width="16"
                            alt="Dashboard"
                          />
                        </div>
                        <div className="dbConfigData">
                          <p>Original Overdue Activities</p>
                          <h4>
                            {taskActionMetrics.overdueTaskActionCount
                              ? taskActionMetrics.overdueTaskActionCount
                              : 0}
                          </h4>
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="iconBox">
                          <img
                            src={Images.VIEWDATA}
                            width="16"
                            alt="Dashboard"
                          />
                        </div>
                        <div className="dbConfigData">
                          <p>Projected Overdue Activities</p>
                          <h4>
                            {taskActionMetrics.projectedOverdueTaskActionCount
                              ? taskActionMetrics.projectedOverdueTaskActionCount
                              : 0}
                          </h4>
                        </div>
                      </div>
                      {/* End  */}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Task KPI End */}
            <div>
              {isReportLoaded ? (
                <div className="switchReport">
                  <RadioGroup
                    aria-label="gender"
                    name="gender1"
                    value={value}
                    defaultValue={"0"}
                    onChange={handlereport}
                  >
                    <FormControlLabel
                      value="RiskRegister"
                      control={<Radio />}
                      label={
                        secureLocalStorage.getItem("isTasksModuleEnabled") === true
                          ? "Risk / Task Register"
                          : "Risk Register"
                      }
                    />
                    <FormControlLabel
                      value="Reports"
                      control={<Radio />}
                      label="Reports"
                    />
                  </RadioGroup>
                </div>
              ) : (
                <div className="switchReportdisable">
                  <RadioGroup
                    aria-label="gender"
                    name="gender1"
                    value={"RiskRegister"}
                  >
                    <FormControlLabel
                      value="RiskRegister"
                      control={<Radio />}
                      label="Risk Register"
                    />
                    <FormControlLabel
                      value="Reports"
                      control={<Radio />}
                      label="Reports"
                    />
                  </RadioGroup>
                </div>
              )}
            </div>
            {/* //200 */}
            {value === "Reports" && (
              <div className="widgetContainer">
                <div className="wGridCont reportCont">
                  <Sortable
                    idField={"widgetId"}
                    disabledField={"disabled"}
                    data={recentChartData}
                    emptyItemUI={(props) => <p></p>}
                    itemUI={(props) => (
                      <SortableWidgetUiHome
                        {...props}
                        changeLineChartWidth={changeLineChartWidth}
                        removeFromHome={removeFromHome}
                        customFieldsmaster={customFieldsData}
                        HeatMapConfigDataOpportunity={
                          HeatMapConfigDataOpportunity
                        }
                        HeatMapConfigDataThreat={HeatMapConfigDataThreat}
                        dynamicHeatmapProbabilityRange={
                          dynamicHeatmapProbabilityRange
                        }
                        refreshTextNarative={refreshTextNarative}
                      />
                    )}
                    onDragEnd={onDragEnd}
                    onNavigate={onNavigate}
                  />
                </div>
              </div>
            )}

            {/* //Here */}
            {value === "RiskRegister" && (
              <div className="tableConts">
                <div className="projectListCont">
                  <div className="gridBox" id="homepagerisk">
                    {/* <div className="Div orgtable"> */}
                    <div
                      id="DataGrid"
                      className="mitigationGrid riskGridsCnts tblCont dataGrids "
                    >
                      {/* start */}

                      <div className="risk-header">
                        <label style={{ color: "#ffffff" }}> My Risks</label>

                        <button
                          className="homeresetrisk"
                          onClick={() => resetPopupOpen("RISK")}
                        >
                          <label> Reset Risk</label>
                        </button>
                        <button
                          className="homeresetrisk"
                          onClick={() => resetPopupOpen("ACTION-EXPAND-HOME")}
                        >
                          <label> Reset Action</label>
                        </button>
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        {riskLoad && (
                          <h1 className="loading">
                            Loading Risks
                            <span className="dot-one"> .</span>
                            <span className="dot-two"> .</span>
                            <span className="dot-three"> .</span>
                          </h1>
                        )}
                        {getuserrole()}
                        {Enableselectuser ? (
                          <div className="select_user_risk">
                            <label>Select User</label>
                            <DropDownList
                              style={{ height: "28px" }}
                              onChange={handleRiskOwner}
                              value={
                                riskOwnerByTenant ||
                                userListdropdown.find(
                                  (item) =>
                                    item.text ===
                                    secureLocalStorage.getItem("userName")
                                )
                              }
                              data={userListdropdown.filter(
                                (obj1, i, arr) =>
                                  arr.findIndex(
                                    (obj2) => obj2.text === obj1.text
                                  ) === i
                              )}
                              valueField="value"
                              textField="text"
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      {/* end */}
                      <div className="rw-tab-content" id="rw-tab-header">
                        {resetFlag === "RISK" ? (
                          <p className="refreshGrid">
                            Refreshing grid, please wait...
                          </p>
                        ) : (
                          <Grid
                            // style={{ minHeight: "100px" }}
                            data={process(data, dataState)}
                            reorderable={data.length == 0 ? false : true}
                            resizable={data.length == 0 ? false : true}
                            pageable={true}
                            // sortable={true}
                            onItemChange={itemChange}
                            cellRender={cellRender}
                            rowRender={rowRender}
                            editField="inEdit"
                            groupable={false}
                            expandField="expanded"
                            filterOperators={filterOperators}
                            {...dataState}
                            onDataStateChange={(e) => {
                              setDataState(e.dataState);
                            }}
                            detail={(props) => (
                              <MitigationExpandEdit
                                {...props}
                                getRiskRegistorList={homeRisksByOwner}
                                refreshRisk={refreshRisk}
                                ownerListForMitigation={ownerListForRisk}
                                stackeHolderList={stackeHolderList}
                                actionTypeListForRisk={actionTypeListForRisk}
                                persistenceActionGrid={persistenceActionExpandGrid}
                                refreshPersistence={refreshExpandAction}
                                orgUnit={orgUnit}
                                heatMapCount={heatmapCount}
                                pageName={"Home"}
                              />
                            )}
                            sortable={{
                              allowUnsort: true,
                              mode: "multiple",
                            }}
                            // sort={sort}
                            // onSortChange={sortChange}
                            onFilterChange={filterChangeExisting}
                            onColumnReorder={onColumnReorder}
                            onColumnResize={(e) => onColumnResize(e)}
                            filter={filter}
                          >
                            <GridColumn
                              // locked={fixedGrid}
                              cell={expandCell}
                              width="42px"
                              title=""
                              headerClassName="no-drag"
                              // minResizableWidth="42"
                              resizable={false}
                              orderIndex={0}
                              reorderable={false}
                            />
                            <GridColumn
                              // locked={fixedGrid}
                              cell={actionButtonsForViewOnly}
                              width="65px"
                              filterable={false}
                              orderIndex={0}
                              headerClassName="no-drag"
                              // minResizableWidth="65"
                              resizable={false}
                              reorderable={false}
                            />
                            <GridColumn
                              locked={fixedGrid}
                              field="organizationUnitName"
                              title="Workstream"
                              width="180px"
                              editable={false}
                              orderIndex={0}
                              minResizableWidth={100}
                              reorderable={false}
                              resizable={false}
                              headerClassName={`${setClassName("organizationUnitName")} no-drag`}
                              columnMenu={(props) => (
                                <ColumnMenuFilter
                                  {...props}
                                  getSelectedColumn={getSelectedColumn}
                                />
                              )}
                            />
                            <GridColumn
                              locked={fixedGrid}
                              field="number"
                              title="Risk Number"
                              width="120px"
                              editable={false}
                              minResizableWidth={100}
                              orderIndex={0}
                              resizable={false}
                              reorderable={false}
                              columnMenu={(props) => (
                                <ColumnMenuFilter
                                  {...props}
                                  getSelectedColumn={getSelectedColumn}
                                />
                              )}
                              headerClassName={`${setClassName("number")} no-drag`}
                            />
                            {persistenceRiskGrid.map((columns) =>
                              getGridColum(columns)
                            )}
                          </Grid>
                        )}
                      </div>
                    </div>
                    {/* </div> */}
                  </div>
                  <div className="gridBox" style={{ "marginTop": "8px" }}>
                    <div className=" Div orgtable" id="orgtable">
                      <div
                        className="mitigationGrid riskGridsCnts tblCont dataGrids "
                        id="rw-tab-header"
                      >
                        <div className="risk-header">
                          <label style={{ color: "#ffffff" }}>
                            {" "}
                            My Actions{" "}
                          </label>
                          <button
                            className="homeresetrisk"
                            onClick={() => resetPopupOpen("ACTION")}
                          >
                            <label> Reset Action</label>
                          </button>
                          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                          {actionLoad && (
                            <h1 className="loading">
                              Loading Actions
                              <span className="dot-one"> .</span>
                              <span className="dot-two"> .</span>
                              <span className="dot-three"> .</span>
                            </h1>
                          )}
                          {Enableselectuser ? (
                            <div className="select_user_action">
                              <label>Select User</label>
                              <DropDownList
                                style={{ height: "28px" }}
                                onChange={handleActionOwner}
                                value={
                                  actionOwnerByTenant ||
                                  userListdropdown.find(
                                    (item) =>
                                      item.text ===
                                      secureLocalStorage.getItem("userName")
                                  )
                                }
                                data={userListdropdown.filter(
                                  (obj1, i, arr) =>
                                    arr.findIndex(
                                      (obj2) => obj2.text === obj1.text
                                    ) === i
                                )}
                                valueField="value"
                                textField="text"
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>

                        <div className="rw-tab-content">
                          {resetFlag === "ACTION" ? (
                            <p className="refreshGrid">
                              Refreshing grid, please wait...
                            </p>
                          ) : (
                            <RecentlyViewedActions
                              mitigationData={riskActionData}
                              ownerListForMitigation={ownerListForRisk}
                              stackeHolderList={stackeHolderList}
                              refreshAction={refreshAction}
                              persistenceActionGrid={persistenceActionGrid}
                              actionTypeListForRisk={actionTypeListForRisk}
                              organisationUnitList={organisationUnitListForRisk}
                              heatMapCount={heatmapCount}
                              value={value}
                            ></RecentlyViewedActions>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {secureLocalStorage.getItem("isTasksModuleEnabled") === true ? (
                    <div className="gridBox" style={{ "marginTop": "8px" }}>
                      <div className=" Div orgtable" id="orgtable">
                        <div
                          className="mitigationGrid riskGridsCnts tblCont dataGrids "
                          id="rw-tab-header"
                        >
                          <div className="risk-header">
                            <label style={{ color: "#ffffff" }}>
                              {" "}
                              My Tasks{" "}
                            </label>
                            <button
                              className="homeresetrisk"
                              onClick={() => resetPopupOpen("TASK")}
                            >
                              <label> Reset Task</label>
                            </button>
                             <button
                              className="homeresetrisk"
                              onClick={() => resetPopupOpen("ACTIVITY-EXPAND-HOME")}
                            >
                              <label> Reset Activity</label>
                            </button>
                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            {taskLoad && (
                              <h1 className="loading">
                                Loading Tasks
                                <span className="dot-one"> .</span>
                                <span className="dot-two"> .</span>
                                <span className="dot-three"> .</span>
                              </h1>
                            )}
                            {Enableselectuser ? (
                              <div className="select_user_action">
                                <label>Select User</label>
                                <DropDownList
                                  style={{ height: "28px" }}
                                  onChange={handleTasklist}
                                  value={
                                    taskOwnerByTenant ||
                                    userListdropdown.find(
                                      (item) =>
                                        item.text ===
                                        secureLocalStorage.getItem("userName")
                                    )
                                  }
                                  data={userListdropdown.filter(
                                    (obj1, i, arr) =>
                                      arr.findIndex(
                                        (obj2) => obj2.text === obj1.text
                                      ) === i
                                  )}
                                  valueField="value"
                                  textField="text"
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </div>

                          <div className="rw-tab-content">
                            {resetFlag === "TASK" ? (
                              <p className="refreshGrid">
                                Refreshing grid, please wait...
                              </p>
                            ) : (
                              <RecentlyViewedTasks
                                taskOwnerByTenant={taskOwnerByTenant}
                                priorityRankingsList={priorityRankingsList}
                                effortUnitId={effortUnitId}
                                ownerList={ownerListForRisk}
                                stackeHolderList={stackeHolderList}
                                organisationUnitList={
                                  organisationUnitListForTask
                                }
                                persistenceActivityExpandGrid={persistenceActivityExpandGrid}
                                persistenceTaskGrid={persistenceTaskGrid}
                                refreshExpandActivity={refreshExpandActivity}
                              ></RecentlyViewedTasks>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {secureLocalStorage.getItem("isTasksModuleEnabled") === true ? (
                    <div className="gridBox" style={{ "marginTop": "8px" }}>
                      <div className=" Div orgtable" id="orgtable">
                        <div
                          className="mitigationGrid riskGridsCnts tblCont dataGrids "
                          id="rw-tab-header"
                        >
                          <div className="risk-header">
                            <label style={{ color: "#ffffff" }}>
                              {" "}
                              My Activities{" "}
                            </label>
                            <button
                              className="homeresetrisk"
                              onClick={() => resetPopupOpen("ACTIVITY")}
                            >
                              <label> Reset Activity</label>
                            </button>
                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            {taskLoad && (
                              <h1 className="loading">
                                Loading Activities
                                <span className="dot-one"> .</span>
                                <span className="dot-two"> .</span>
                                <span className="dot-three"> .</span>
                              </h1>
                            )}
                            {Enableselectuser ? (
                              <div className="select_user_action">
                                <label>Select User</label>
                                <DropDownList
                                  style={{ height: "28px" }}
                                  onChange={handleSubTasklist}
                                  value={
                                    taskActionsOwnerByTenant ||
                                    userListdropdown.find(
                                      (item) =>
                                        item.text ===
                                        secureLocalStorage.getItem("userName")
                                    )
                                  }
                                  data={userListdropdown.filter(
                                    (obj1, i, arr) =>
                                      arr.findIndex(
                                        (obj2) => obj2.text === obj1.text
                                      ) === i
                                  )}
                                  valueField="value"
                                  textField="text"
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </div>

                          <div className="rw-tab-content">
                            {resetFlag === "ACTIVITY" ? (
                              <p className="refreshGrid">
                                Refreshing grid, please wait...
                              </p>
                            ) : (
                              <RecentlyViewedTasksActions
                                taskActionsList={taskActionsList}
                                refreshTaskAction={homeTaskActionsByOwner}
                                priorityRankingsList={priorityRankingsList}
                                effortUnitId={effortUnitId}
                                ownerList={ownerListForRisk}
                                stackeHolderList={stackeHolderList}
                                organisationUnitList={
                                  organisationUnitListForTask
                                }
                                persistenceTaskActionGrid={
                                  persistenceTaskActionGrid
                                }
                                customFieldsmaster={customFieldsData}
                                ref={myrecentactivity}
                              ></RecentlyViewedTasksActions>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Popup show={resetPopup} popupClass={"popup-content"}>
        {loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        <div className="deleteModelCont">
          <h3>
            {riskOrAction === "RISK"
              ? "Are you sure you want to reset Risk register?"
              : riskOrAction === "TASK"
              ? "Are you sure you want to reset Task register?"
              : riskOrAction === "ACTIVITY" || riskOrAction === "ACTIVITY-EXPAND-HOME"
              ? "Are you sure you want to reset this Activity register ?"
              : "Are you sure you want to reset this Action register?"}
          </h3>
          <div className="btnCont">
            <button
              onClick={() =>
                riskOrAction === "RISK"
                  ? resetPersistence()
                  : riskOrAction === "TASK"
                    ? resetTaskPersistence()
                    : riskOrAction === "ACTIVITY"
                      ? resetActivityPersistence()
                      : riskOrAction === "ACTION-EXPAND-HOME"
                        ? resetExpandActionPersistence() : riskOrAction === "ACTIVITY-EXPAND-HOME"
                          ? resetExpandActivityPersistence() : resetActionPersistence()
              }
              className="deleteBtn"
            >
              Reset
            </button>
            <button onClick={resetPopupClose} className="cancelBtn">
              Cancel
            </button>
          </div>
        </div>
      </Popup>
    </div>
  );
}
